"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4799],{

/***/ 77472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Row_Row; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/Row.styles.js

var _templateObject;


var Box = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/Row.js




var Row = function Row(_ref) {
  var StaticProps = _ref["static"],
    children = _ref.children;
  return react.createElement(Box, StaticProps, children);
};
 false ? 0 : void 0;
Row.defaultProps = {
  "static": {}
};
Row.ssr = true;
Row.displayName = 'Row';
/* harmony default export */ var Row_Row = ((0,withLayoutProps/* default */.Z)(Row));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Row/index.js


/***/ }),

/***/ 73752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchFilters_SearchFilters; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterUnique/FilterUnique.js







var FiltersUnique = function FiltersUnique(_ref) {
  var searchTerm = _ref.searchTerm,
    onClick = _ref.onClick,
    values = _ref.values,
    type = _ref.type;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var reviewLabelFormatter = function reviewLabelFormatter(option) {
    return (option == null ? void 0 : option.hint) ? "".concat(option == null ? void 0 : option.label, " ").concat(option.hint) : "".concat(option == null ? void 0 : option.label);
  };
  var Child = function Child(option) {
    switch (type) {
      case 'review':
        return react.createElement(Review/* default */.Z, {
          min: option == null ? void 0 : option.min,
          max: option == null ? void 0 : option.max,
          label: reviewLabelFormatter(option),
          format: "label",
          score: option == null ? void 0 : option.value
        });
      case 'attribute':
        return option == null ? void 0 : option.label;
      default:
        return option == null ? void 0 : option.label;
    }
  };
  return (values == null ? void 0 : values.length) ? react.createElement(react.Fragment, null, react.createElement(List/* default */.Z, {
    scale: "small",
    searchProperty: "label",
    disableGutters: true,
    dataSource: values,
    renderItem: function renderItem(option) {
      return react.createElement(List/* default.Radio */.Z.Radio, {
        as: "span",
        fontSize: 2,
        value: option == null ? void 0 : option.value,
        selected: option == null ? void 0 : option.selected,
        filterLabel: option == null ? void 0 : option.filterLabel,
        eventLabel: option == null ? void 0 : option.label,
        href: option == null ? void 0 : option.href,
        onChange: onHandleClick,
        position: option == null ? void 0 : option.position
      }, Child(option));
    },
    name: "radio-list-".concat(type),
    "data-testid": "unique-filters"
  })) : null;
};
 false ? 0 : void 0;
FiltersUnique.defaultProps = {
  searchTerm: '',
  type: '',
  values: []
};
FiltersUnique.ssr = true;
/* harmony default export */ var FilterUnique = ((0,withLayoutProps/* default */.Z)(FiltersUnique));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterUnique/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js + 2 modules
var FilterInput = __webpack_require__(99554);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FiltersMultiple/FiltersMultiple.js









var FiltersMultiple = function FiltersMultiple(_ref) {
  var collapsedIn = _ref.collapsedIn,
    searchTerm = _ref.searchTerm,
    displaySearch = _ref.displaySearch,
    onClickCollapse = _ref.onClickCollapse,
    onClick = _ref.onClick,
    values = _ref.values;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    trigger = _useState2[0],
    setTrigger = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    filterTerm = _useState4[0],
    setFilterTerm = _useState4[1];
  (0,react.useEffect)(function () {
    setTrigger((values == null ? void 0 : values.length) >= collapsedIn);
  }, [JSON.stringify(values)]);
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var onHandleInputChange = function onHandleInputChange(e) {
    if (trigger) setTrigger(false);
    setFilterTerm(e.target.value);
  };
  var onHandleCollapseClick = function onHandleCollapseClick() {
    setTrigger(!trigger);
    if (!trigger) onClickCollapse();
  };
  return (values == null ? void 0 : values.length) ? react.createElement(react.Fragment, null, displaySearch && react.createElement(FilterInput/* default */.Z, {
    mb: 3,
    onChange: onHandleInputChange,
    onClearInput: function onClearInput() {
      return setFilterTerm('');
    },
    "data-testid": "filter-input"
  }), react.createElement(List/* default */.Z, {
    scale: "small",
    collapse: (values == null ? void 0 : values.length) >= collapsedIn,
    trigger: trigger,
    collapsedIn: (values == null ? void 0 : values.length) <= collapsedIn ? values == null ? void 0 : values.length : collapsedIn,
    dataSource: values,
    renderItem: function renderItem(filter) {
      return react.createElement(List/* default.Checkbox */.Z.Checkbox, {
        key: filter == null ? void 0 : filter.slug,
        as: "span",
        checked: filter == null ? void 0 : filter.selected,
        fontSize: 2,
        onClick: function onClick(e) {
          return onHandleClick(e, filter);
        },
        "data-testid": "filter-checkbox"
      }, filter == null ? void 0 : filter.label);
    },
    renderAction: (values == null ? void 0 : values.length) >= collapsedIn && react.createElement(List/* default.Action */.Z.Action, null, react.createElement(Link/* default */.Z, {
      color: "text.primary",
      fontWeight: "medium",
      fontSize: 2,
      px: 0,
      onClick: onHandleCollapseClick,
      "data-testid": "filter-action"
    }, trigger ? 'Ver todos' : 'Ver menos')),
    searchProperty: "label",
    searchTerm: filterTerm,
    sortBy: function sortBy(_ref2) {
      var selected = _ref2.selected;
      return selected ? -1 : 1;
    },
    disableGutters: true
  })) : null;
};
 false ? 0 : void 0;
FiltersMultiple.defaultProps = {
  collapsedIn: 5,
  displaySearch: false,
  onClick: function onClick() {},
  onClickCollapse: function onClickCollapse() {},
  searchTerm: '',
  values: []
};
FiltersMultiple.ssr = true;
/* harmony default export */ var FiltersMultiple_FiltersMultiple = ((0,withLayoutProps/* default */.Z)(FiltersMultiple));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FiltersMultiple/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterHierarchical/FilterHierarchical.js








var FilterHierarchical = function FilterHierarchical(_ref) {
  var onClick = _ref.onClick,
    searchTerm = _ref.searchTerm,
    values = _ref.values,
    collapsedIn = _ref.collapsedIn,
    onClickCollapse = _ref.onClickCollapse;
  var _useState = (0,react.useState)(true),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    trigger = _useState2[0],
    setTrigger = _useState2[1];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  (0,react.useEffect)(function () {
    setTrigger((values == null ? void 0 : values.length) >= collapsedIn);
  }, [JSON.stringify(values)]);
  var onHandleClick = function onHandleClick(e, filter) {
    e.preventDefault();
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, filter));
    onClick(e, filter);
  };
  var onHandleCollapseClick = function onHandleCollapseClick() {
    setTrigger(!trigger);
    if (!trigger) onClickCollapse();
  };
  return react.createElement(List/* default */.Z, {
    scale: "small",
    disableGutters: true,
    dataSource: values,
    collapse: (values == null ? void 0 : values.length) >= collapsedIn,
    trigger: trigger,
    collapsedIn: (values == null ? void 0 : values.length) <= collapsedIn ? values == null ? void 0 : values.length : collapsedIn,
    renderItem: function renderItem(filter) {
      return react.createElement(List/* default.Item */.Z.Item, {
        key: "".concat(filter.id, "-").concat(filter.slug),
        fill: "background.primary",
        filterPosition: filter.position,
        fontSize: 2,
        textAlign: "initial",
        startIcon: filter.icon,
        as: filter.href && 'a',
        href: filter.href,
        inset: filter.inset,
        fontWeight: !filter.href && 'bold',
        onClick: function onClick(e) {
          return filter.href && onHandleClick(e, filter);
        }
      }, filter.label);
    },
    renderAction: (values == null ? void 0 : values.length) >= collapsedIn && react.createElement(List/* default.Action */.Z.Action, null, react.createElement(Link/* default */.Z, {
      color: "text.primary",
      fontWeight: "medium",
      fontSize: 2,
      px: 0,
      onClick: onHandleCollapseClick,
      "data-testid": "filter-action"
    }, trigger ? 'Ver todos' : 'Ver menos'))
  });
};
 false ? 0 : void 0;
FilterHierarchical.defaultProps = {
  collapsedIn: 5,
  onClickCollapse: function onClickCollapse() {},
  searchTerm: '',
  values: []
};
FilterHierarchical.ssr = true;
/* harmony default export */ var FilterHierarchical_FilterHierarchical = ((0,withLayoutProps/* default */.Z)(FilterHierarchical));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterHierarchical/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/PriceRange/index.js + 2 modules
var PriceRange = __webpack_require__(58125);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterPrice/FilterPrice.js


var _excluded = ["searchTerm", "onApply"],
  _excluded2 = ["buildHref"];





var FilterPrice = function FilterPrice(_ref) {
  var searchTerm = _ref.searchTerm,
    onApply = _ref.onApply,
    filterProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var max = filterProps.max,
    min = filterProps.min,
    selectedMin = filterProps.selectedMin,
    selectedMax = filterProps.selectedMax;
  var handleApply = function handleApply(e, appliedRange, filter) {
    e.preventDefault();
    var buildHref = filter.buildHref,
      appliedFilter = (0,objectWithoutProperties/* default */.Z)(filter, _excluded2);
    publish('productlist:filter:click', (0,esm_extends/* default */.Z)({
      searchTerm: searchTerm
    }, appliedFilter, {
      selectedMax: appliedRange.max,
      selectedMin: appliedRange.min
    }));
    onApply(e, appliedRange, filter);
  };
  return react.createElement(PriceRange/* default */.Z, {
    item: filterProps,
    max: max,
    min: min,
    initialMax: selectedMax,
    initialMin: selectedMin,
    onApply: handleApply
  });
};
 false ? 0 : void 0;
FilterPrice.defaultProps = {
  searchTerm: '',
  selectedMax: undefined,
  selectedMin: undefined
};
FilterPrice.ssr = true;
/* harmony default export */ var FilterPrice_FilterPrice = ((0,withLayoutProps/* default */.Z)(FilterPrice));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/FilterPrice/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/index.js + 2 modules
var Accordion = __webpack_require__(50616);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/SearchFilters.styles.js


var _templateObject;


var AccordionStyled = (0,styled_components_browser_esm/* default */.ZP)(Accordion/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    padding: '12px !important'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/SearchFilters.js















var SearchFilters = function SearchFilters(_ref) {
  var _data$search2, _structure$route;
  var data = _ref.data,
    structure = _ref.structure,
    _ref$static = _ref["static"],
    _ref$static$customCat = _ref$static.customCategoryFilter,
    customCategoryFilter = _ref$static$customCat === void 0 ? false : _ref$static$customCat,
    _ref$static$searchTer = _ref$static.searchTerm,
    searchTerm = _ref$static$searchTer === void 0 ? '' : _ref$static$searchTer,
    _ref$static$displayOp = _ref$static.displayOpened,
    displayOpened = _ref$static$displayOp === void 0 ? 8 : _ref$static$displayOp,
    _ref$static$displaySe = _ref$static.displaySearch,
    displaySearch = _ref$static$displaySe === void 0 ? [] : _ref$static$displaySe,
    _ref$static$removeFil = _ref$static.removeFilters,
    removeFilters = _ref$static$removeFil === void 0 ? [] : _ref$static$removeFil,
    uniqueFiltersConfig = _ref$static.uniqueFilters;
  var refs = (0,react.useRef)({});
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var query = structure.query;
  var sortFilters = function sortFilters() {
    var _data$search;
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filterBySlug = filters.reduce(function (acc, filter) {
      return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, filter.slug, filter));
    }, {});
    var baseFilters = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.filters) || [];
    return baseFilters.reduce(function (acc, _ref2) {
      var _filterBySlug$slug, _filterBySlug$slug$va, _filterBySlug$slug2;
      var slug = _ref2.slug;
      return filterBySlug[slug] && (((_filterBySlug$slug = filterBySlug[slug]) == null ? void 0 : (_filterBySlug$slug$va = _filterBySlug$slug.values) == null ? void 0 : _filterBySlug$slug$va.length) || ((_filterBySlug$slug2 = filterBySlug[slug]) == null ? void 0 : _filterBySlug$slug2.componentType) === 'priceRange') ? [].concat((0,toConsumableArray/* default */.Z)(acc), [filterBySlug[slug]]) : acc;
    }, []);
  };
  var buildFilterFilters = function buildFilterFilters() {
    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _filtersParser = (0,esm/* filtersParser */.U8)({
        customCategoryFilter: customCategoryFilter,
        data: data,
        filters: filters,
        query: query,
        removeFilters: removeFilters,
        structure: structure
      }),
      attributeFilters = _filtersParser.attributeFilters,
      reviewFilters = _filtersParser.reviewFilters,
      categoryFilters = _filtersParser.categoryFilters,
      priceFilters = _filtersParser.priceFilters;
    var newParsedFilters = attributeFilters.map(function (filter) {
      var componentType = uniqueFiltersConfig.some(function (uniqueFilterConfig) {
        return (0,esm/* hasSomeEqualProp */.dD)(filter, uniqueFilterConfig);
      }) ? 'unique' : 'multiple';
      return (0,esm_extends/* default */.Z)({}, filter, {
        componentType: componentType
      });
    });
    if (reviewFilters) {
      reviewFilters.componentType = 'unique';
      newParsedFilters.push(reviewFilters);
    }
    if (categoryFilters) {
      categoryFilters.componentType = 'hierarchical';
      newParsedFilters.push(categoryFilters);
    }
    if (priceFilters) {
      priceFilters.componentType = 'priceRange';
      newParsedFilters.push(priceFilters);
    }
    return sortFilters(newParsedFilters);
  };
  var toggleDisplayOpened = function toggleDisplayOpened(currentFilters) {
    return currentFilters.slice(0, displayOpened).reduce(function (acc, filter) {
      return (0,esm_extends/* default */.Z)({}, acc, (0,defineProperty/* default */.Z)({}, filter.slug, true));
    }, {});
  };
  var parsedFilters = buildFilterFilters(data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : _data$search2.filters);
  var _useState = (0,react.useState)(toggleDisplayOpened(parsedFilters)),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    collapse = _useState2[0],
    collapsableSet = _useState2[1];
  var _useState3 = (0,react.useState)(parsedFilters),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    allFilters = _useState4[0],
    allFiltersSet = _useState4[1];
  var toggleCollapse = function toggleCollapse(slug) {
    var action = (collapse == null ? void 0 : collapse[slug]) ? 'close' : 'open';
    publish("productlist:filter:".concat(action));
    collapsableSet(function (prev) {
      return (0,esm_extends/* default */.Z)({}, prev, (0,defineProperty/* default */.Z)({}, slug, !(prev == null ? void 0 : prev[slug])));
    });
  };
  var updateFilters = function updateFilters() {
    var _data$search3;
    var updatedFilters = buildFilterFilters(data == null ? void 0 : (_data$search3 = data.search) == null ? void 0 : _data$search3.filters);
    allFiltersSet(updatedFilters);
  };
  (0,react.useEffect)(function () {
    updateFilters();
  }, [JSON.stringify(data)]);
  (0,react.useEffect)(function () {
    collapsableSet(toggleDisplayOpened(parsedFilters));
  }, [structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term]);
  var onFilterItemClick = function onFilterItemClick(e, filter) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: filter == null ? void 0 : filter.href,
      spa: true
    });
  };
  var onFilterPriceApply = function onFilterPriceApply(e, _ref3, filter) {
    var min = _ref3.min,
      max = _ref3.max;
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: filter == null ? void 0 : filter.buildHref(max, min),
      spa: true
    });
  };
  var renderMultiple = function renderMultiple(_ref4) {
    var type = _ref4.type,
      values = _ref4.values;
    return react.createElement(FiltersMultiple_FiltersMultiple, {
      values: values,
      searchTerm: searchTerm,
      displaySearch: displaySearch == null ? void 0 : displaySearch.includes(type),
      onClickCollapse: function onClickCollapse() {
        return (0,esm/* scrollToRef */.BC)({
          current: refs.current[type]
        });
      },
      onClick: onFilterItemClick
    });
  };
  var renderUnique = function renderUnique(_ref5) {
    var type = _ref5.type,
      values = _ref5.values;
    return react.createElement(FilterUnique, {
      values: values,
      type: type,
      searchTerm: searchTerm,
      onClick: onFilterItemClick
    });
  };
  var renderHierarchical = function renderHierarchical(_ref6) {
    var type = _ref6.type,
      values = _ref6.values;
    return react.createElement(FilterHierarchical_FilterHierarchical, {
      values: values,
      type: type,
      searchTerm: searchTerm,
      onClick: onFilterItemClick,
      onClickCollapse: function onClickCollapse() {
        return (0,esm/* scrollToRef */.BC)({
          current: refs.current[type]
        });
      }
    });
  };
  var renderPrice = function renderPrice(filterProps) {
    return react.createElement(FilterPrice_FilterPrice, (0,esm_extends/* default */.Z)({}, filterProps, {
      searchTerm: searchTerm,
      onApply: onFilterPriceApply
    }));
  };
  var renderByType = {
    hierarchical: renderHierarchical,
    multiple: renderMultiple,
    priceRange: renderPrice,
    unique: renderUnique
  };
  return react.createElement(Box/* default */.Z, {
    "data-testid": "search-filters"
  }, allFilters == null ? void 0 : allFilters.map(function (filterItem) {
    var componentType = filterItem.componentType,
      type = filterItem.type,
      slug = filterItem.slug,
      label = filterItem.label;
    return react.createElement(react.Fragment, null, react.createElement(AccordionStyled, {
      ref: function ref(element) {
        refs.current["".concat(type, "-").concat(slug)] = element;
      },
      asTitle: "p",
      key: "".concat(type, "-").concat(slug),
      title: label,
      open: collapse == null ? void 0 : collapse[slug],
      onClick: function onClick() {
        return toggleCollapse(slug);
      },
      openIcon: "ChevronDown",
      closeIcon: "ChevronUp",
      mb: 2,
      mt: 2,
      borderRadius: 10,
      "data-testid": "accordion-".concat(componentType, "-filters")
    }, renderByType[componentType](filterItem)));
  }));
};
 false ? 0 : void 0;
SearchFilters.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
SearchFilters.ssr = true;
/* harmony default export */ var SearchFilters_SearchFilters = ((0,withLayoutProps/* default */.Z)(SearchFilters));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchFilters/index.js


/***/ }),

/***/ 13288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchHeader_SearchHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/SearchHeader.styles.js

var _templateObject;


var CountLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  margin-right: auto;\n"])), function (props) {
  return (0,build_esm/* getTextColor */.uu)('light')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/SearchHeader.js






var SearchHeader = function SearchHeader(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var countLabel = staticProps.countLabel;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    pagination = _ref2.pagination;
  var recordsTitle = {
    label: countLabel,
    records: pagination == null ? void 0 : pagination.records
  };
  return react.createElement(Flex/* default */.Z, {
    alignContent: "space-between"
  }, (pagination == null ? void 0 : pagination.records) && react.createElement(CountLabel, null, (0,esm/* parseRecordsTitle */.LZ)(recordsTitle)));
};
 false ? 0 : void 0;
SearchHeader.defaultProps = {
  data: {},
  "static": {}
};
SearchHeader.ssr = true;
/* harmony default export */ var SearchHeader_SearchHeader = ((0,withLayoutProps/* default */.Z)(SearchHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchHeader/index.js


/***/ }),

/***/ 70134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchOrder_SearchOrder; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/index.js + 2 modules
var Select = __webpack_require__(73002);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchOrder/SearchOrder.js








var SearchOrder = function SearchOrder(_ref) {
  var _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure;
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    sorts = _ref2.sorts;
  var selectedOption = (_structure$route = structure.route) == null ? void 0 : _structure$route.sortType;
  var selectedOrientation = (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.sortOrientation;
  var onChange = function onChange(label) {
    var _sorts$filter = sorts == null ? void 0 : sorts.filter(function (item) {
        return item.label === label;
      }),
      _sorts$filter2 = (0,slicedToArray/* default */.Z)(_sorts$filter, 1),
      sort = _sorts$filter2[0];
    if (sort) {
      var sortType = sort.type,
        sortOrientation = sort.orientation;
      publish('productlist:sort:change', {
        sort: sort
      });
      var path = (0,esm/* getCurrentPath */.Jz)({
        page: 1,
        sortOrientation: sortOrientation,
        sortType: sortType
      });
      (0,esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  };
  var options = sorts == null ? void 0 : sorts.reduce(function (acc, sort) {
    if (selectedOption && selectedOrientation && sort.type === selectedOption && sort.orientation === selectedOrientation) {
      return [{
        label: sort.label,
        selected: true,
        value: sort.label
      }].concat((0,toConsumableArray/* default */.Z)(acc));
    }
    return [].concat((0,toConsumableArray/* default */.Z)(acc), [{
      label: sort.label,
      selected: false,
      value: sort.label
    }]);
  }, []);
  return options ? react.createElement(Select/* default */.Z, {
    desktopMode: true,
    id: "desktop-with-label",
    textLabel: "Ordenar por",
    options: options,
    onChange: onChange
  }) : null;
};
 false ? 0 : void 0;
SearchOrder.defaultProps = {
  data: {},
  structure: {}
};
SearchOrder.ssr = true;
/* harmony default export */ var SearchOrder_SearchOrder = ((0,withLayoutProps/* default */.Z)(SearchOrder));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchOrder/index.js


/***/ }),

/***/ 33429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchRecommendation_SearchRecommendation; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchRecommendation/SearchRecommendation.js











var SearchRecommendation = function SearchRecommendation(_ref) {
  var _recommendation$produ, _structure$cookies, _structure$cookies$ac, _structure$route;
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _ref2 = structure.route || {},
    term = _ref2.term,
    filters = _ref2.filters,
    sortOrientation = _ref2.sortOrientation,
    sortType = _ref2.sortType,
    _ref2$page = _ref2.page,
    page = _ref2$page === void 0 ? 1 : _ref2$page;
  var _ref3 = (structure == null ? void 0 : structure.config) || {},
    domain = _ref3.domain;
  var _ref4 = (structure == null ? void 0 : structure.cookies) || {},
    _ref4$location = _ref4.location,
    location = _ref4$location === void 0 ? {} : _ref4$location,
    partnerId = _ref4.partnerId,
    _ref4$customerId = _ref4.customerId,
    customerId = _ref4$customerId === void 0 ? '0' : _ref4$customerId;
  var _staticProps$display = staticProps.display,
    display = _staticProps$display === void 0 ? 'list' : _staticProps$display,
    _staticProps$origin = staticProps.origin,
    origin = _staticProps$origin === void 0 ? 'doory' : _staticProps$origin,
    _staticProps$pageSize = staticProps.pageSize,
    pageSize = _staticProps$pageSize === void 0 ? 20 : _staticProps$pageSize,
    _staticProps$spa = staticProps.spa,
    spa = _staticProps$spa === void 0 ? false : _staticProps$spa,
    _staticProps$type = staticProps.type,
    type = _staticProps$type === void 0 ? 'list' : _staticProps$type,
    _staticProps$carousel = staticProps.carouselConfig,
    carouselConfig = _staticProps$carousel === void 0 ? {} : _staticProps$carousel;
  var _useRecommendation = (0,build_esm.useRecommendation)({
      customerId: customerId,
      filters: filters,
      location: location,
      partnerId: partnerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      term: term
    }),
    recommendation = _useRecommendation.recommendation;
  var productsParsed = recommendation == null ? void 0 : (_recommendation$produ = recommendation.products) == null ? void 0 : _recommendation$produ.map(function (product, index) {
    var path = product.path;
    var url = (0,esm/* parsePath */.cP)(path);
    var position = (page - 1) * pageSize + (index + 1);
    return (0,esm_extends/* default */.Z)({}, product, {
      position: position,
      url: url
    });
  });
  var eventData = {
    customer_id: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id,
    display: display,
    filters: filters,
    list: recommendation == null ? void 0 : recommendation.title,
    listPosition: 2,
    origin: origin,
    pageName: structure == null ? void 0 : structure.name,
    term: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.term,
    type: 'recomendacao'
  };
  (0,react.useEffect)(function () {
    if (productsParsed) {
      publish('productlist:impression', (0,esm_extends/* default */.Z)({}, eventData, {
        products: productsParsed
      }));
    }
  }, [recommendation]);
  var handleProductView = function handleProductView(product) {
    publish('product:view', (0,esm_extends/* default */.Z)({}, eventData, {
      product: (0,esm_extends/* default */.Z)({}, product, {
        position: product.index + 1
      })
    }));
    publish('product:viewItemList', (0,esm_extends/* default */.Z)({}, eventData, product));
  };
  var handleProductClick = (0,react.useCallback)(function (e, product) {
    publish('productlist:selectItem:click', (0,esm_extends/* default */.Z)({}, eventData, product));
    publish('productlist:click', (0,esm_extends/* default */.Z)({}, product, eventData));
    if (spa) {
      e.preventDefault();
      (0,esm/* routePush */.dY)({
        path: product.url,
        spa: spa
      });
    }
  }, [recommendation.title]);
  var showcases = {
    carousel: react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
      products: productsParsed,
      displayMode: display,
      onProductView: handleProductView,
      showArrowControls: true,
      showPartialNextSlide: false,
      slidesPerView: 4,
      showControls: false,
      auto: false
    }, carouselConfig)),
    list: react.createElement(ProductList/* default */.Z, {
      onClick: handleProductClick,
      onProductView: handleProductView,
      data: productsParsed,
      displayMode: display,
      domain: domain
    })
  };
  var showcase = showcases[type];
  return react.createElement(react.Fragment, null, productsParsed && react.createElement(Box/* default */.Z, null, react.createElement(Heading/* default */.Z, {
    "data-testid": "recommendation-title",
    as: "h3",
    fontSize: [2, 5, 5, 5],
    fontWeight: "medium",
    m: "0 8px 12px"
  }, recommendation == null ? void 0 : recommendation.title), showcase));
};
 false ? 0 : void 0;
SearchRecommendation.defaultProps = {
  "static": {},
  structure: {
    config: {},
    cookies: {},
    route: {}
  }
};
SearchRecommendation.displayName = 'SearchRecommendation';
SearchRecommendation.ssr = false;
/* harmony default export */ var SearchRecommendation_SearchRecommendation = ((0,withLayoutProps/* default */.Z)(SearchRecommendation));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchRecommendation/index.js


/***/ }),

/***/ 81474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchResultsHeader_SearchResultsHeader; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/SearchResultsHeader.styles.js

var _templateObject;


var CountLabel = styled_components_browser_esm/* default.p */.ZP.p(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"])), function (props) {
  return (0,build_esm/* getTextColor */.uu)('scratched')(props);
}, function (props) {
  return (0,build_esm/* themeGet */.R)('fontSizes.1')(props);
}, function (props) {
  return (0,build_esm/* themeGet */.R)('fontWeights.bold')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/SearchResultsHeader.js





var SearchResultsHeader = function SearchResultsHeader(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"];
  var countLabel = staticProps.countLabel;
  var _ref2 = (data == null ? void 0 : data.search) || {},
    pagination = _ref2.pagination;
  var recordsTitle = {
    label: countLabel,
    records: pagination == null ? void 0 : pagination.records
  };
  return react.createElement(CountLabel, {
    "data-testid": "results-qty-label"
  }, (pagination == null ? void 0 : pagination.records) && (0,esm/* parseRecordsTitle */.LZ)(recordsTitle));
};
 false ? 0 : void 0;
SearchResultsHeader.defaultProps = {
  data: {},
  "static": {}
};
SearchResultsHeader.ssr = true;
/* harmony default export */ var SearchResultsHeader_SearchResultsHeader = ((0,withLayoutProps/* default */.Z)(SearchResultsHeader));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchResultsHeader/index.js


/***/ }),

/***/ 90026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ searchTitle; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchTitle/searchTitle.js



var isDenied = function isDenied(term, deniedTerms) {
  return deniedTerms.indexOf(term) >= 0;
};
var retrieveDeniedContent = function retrieveDeniedContent(terms, deniedTerms, content) {
  return isDenied(terms, deniedTerms) ? content : null;
};
var SearchTitle = function SearchTitle(_ref) {
  var _data$seoSearchConten, _data$seoSearchConten2;
  var structure = _ref.structure,
    staticProps = _ref["static"],
    data = _ref.data;
  var capitalizeWords = function capitalizeWords(str) {
    return str == null ? void 0 : str.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  };
  var _structure$route = structure == null ? void 0 : structure.route,
    term = _structure$route.term;
  var defaultTitle = staticProps.defaultTitle,
    defaultDescription = staticProps.defaultDescription,
    _staticProps$deniedTe = staticProps.deniedTerms,
    deniedTerms = _staticProps$deniedTe === void 0 ? [] : _staticProps$deniedTe,
    deniedDescription = staticProps.deniedDescription,
    allowedDescription = staticProps.allowedDescription;
  var terms = capitalizeWords(term);
  var deniedTitle = "".concat(terms, " | Resultado de Busca Interna | Magazine Luiza");
  var allowedTitle = (data == null ? void 0 : (_data$seoSearchConten = data.seoSearchContent) == null ? void 0 : (_data$seoSearchConten2 = _data$seoSearchConten.meta) == null ? void 0 : _data$seoSearchConten2.title) || "".concat(terms, " em Promo\xE7\xE3o no Magazine Luiza");
  var title = !terms ? defaultTitle : retrieveDeniedContent(term, deniedTerms, deniedTitle) || allowedTitle || defaultTitle;
  var description = !terms ? defaultDescription : retrieveDeniedContent(term, deniedTerms, deniedDescription) || allowedDescription || defaultDescription;
  return react.createElement((head_default()), null, react.createElement("title", {
    "data-testid": "meta-title"
  }, title), react.createElement("meta", {
    "data-testid": "meta-description",
    name: "description",
    content: description
  }));
};
SearchTitle.displayName = 'SearchTitle';
SearchTitle.defaultProps = {
  data: {},
  "static": {
    allowedDescription: '',
    allowedTitle: '',
    defaultDescription: '',
    defaultTitle: '',
    deniedDescription: '',
    deniedTerms: [],
    deniedTitle: ''
  },
  structure: {
    route: {}
  }
};
 false ? 0 : void 0;
SearchTitle.ssr = true;
/* harmony default export */ var searchTitle = (SearchTitle);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SearchTitle/index.js


/***/ }),

/***/ 69991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SelectByRating_SelectByRating; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/RatingLine/index.js + 2 modules
var RatingLine = __webpack_require__(11151);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectByRating/SelectByRating.js










var SelectByRating = function SelectByRating(_ref) {
  var staticProps = _ref["static"],
    data = _ref.data,
    structure = _ref.structure;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var title = staticProps.title;
  var _ref2 = data.productRating || {},
    _ref2$reviewsByRating = _ref2.reviewsByRating,
    reviewsByRating = _ref2$reviewsByRating === void 0 ? [] : _ref2$reviewsByRating,
    _ref2$general = _ref2.general,
    general = _ref2$general === void 0 ? {} : _ref2$general;
  var _ref3 = general || {},
    reviewCount = _ref3.reviewCount;
  var _ref4 = (structure == null ? void 0 : structure.route) || {},
    _ref4$filters = _ref4.filters,
    filters = _ref4$filters === void 0 ? [] : _ref4$filters;
  var reviewsByRatingData = reviewsByRating.sort(function (a, b) {
    return b.rating - a.rating;
  }).map(function (ratingReview) {
    var rating = ratingReview.rating,
      total = ratingReview.total;
    var rate = new Map([[1, 'ONE_STAR'], [2, 'TWO_STARS'], [3, 'THREE_STARS'], [4, 'FOUR_STARS'], [5, 'FIVE_STARS']]);
    return {
      href: "rating---".concat(rate.get(rating)),
      key: rating,
      selected: false,
      total: total,
      type: rate.get(rating),
      value: rating
    };
  });
  var updatedReviewsByRatingData = reviewsByRatingData.map(function (item) {
    var _rating$;
    var rating = filters.filter(function (filter) {
      return filter.type === 'rating';
    }).map(function (filter) {
      return {
        type: filter.type,
        value: filter.value
      };
    });
    if (item.type === ((_rating$ = rating[0]) == null ? void 0 : _rating$.value)) {
      return (0,esm_extends/* default */.Z)({}, item, {
        selected: true
      });
    }
    return item;
  });
  var _useState = (0,react.useState)(updatedReviewsByRatingData),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  (0,react.useEffect)(function () {
    setOptions(updatedReviewsByRatingData);
  }, [filters]);
  var handleSubmitFilter = function handleSubmitFilter(filter, type) {
    var _rating$2;
    var rating = filters.filter(function (item) {
      return item.type === 'rating';
    }).map(function (item) {
      return {
        type: item.type,
        value: item.value
      };
    });
    if (((_rating$2 = rating[0]) == null ? void 0 : _rating$2.value) !== type) {
      var path = (0,build_esm/* getCurrentPath */.Jz)({
        filters: filter.href,
        page: 1
      });
      (0,build_esm/* routePush */.dY)({
        path: path,
        spa: true
      });
    }
  };
  var _onChange = function onChange(filter, total, type) {
    if (total !== 0) {
      var newValue = options.map(function (item) {
        var same = item.value === filter.value;
        return (0,esm_extends/* default */.Z)({}, item, {
          selected: !!same
        });
      });
      setOptions(newValue);
      handleSubmitFilter(filter, type);
      publish('review:filter:click', type, {
        data: data,
        structure: structure
      });
    }
  };
  return !!(reviewsByRating == null ? void 0 : reviewsByRating.length) && !!reviewCount && react.createElement(Box/* default */.Z, {
    bg: "background.white",
    "data-testid": "select-by-rating-container"
  }, react.createElement(Text/* default */.Z, {
    pb: 3,
    fontWeight: "medium",
    fontSize: 2
  }, title), react.createElement(List/* default */.Z, {
    disableGutters: true,
    scale: "small",
    dataSource: options,
    renderItem: function renderItem(option) {
      return react.createElement(List/* default.Radio */.Z.Radio, {
        as: "span",
        p: 3,
        key: option == null ? void 0 : option.key,
        value: option == null ? void 0 : option.value,
        selected: option == null ? void 0 : option.selected,
        onChange: function onChange() {
          return _onChange(option, option == null ? void 0 : option.total, option == null ? void 0 : option.type);
        },
        fontSize: 2,
        filterLabel: option == null ? void 0 : option.value,
        href: option == null ? void 0 : option.href,
        "data-testid": "radio-button"
      }, react.createElement(RatingLine/* default */.Z, {
        as: "div",
        count: (option == null ? void 0 : option.total) <= 999 ? "".concat(option == null ? void 0 : option.total) : '+999',
        id: option == null ? void 0 : option.value,
        max: reviewCount,
        score: option == null ? void 0 : option.total,
        starColor: "#FFCC03",
        lineColor: "#0086ff",
        fontweightScore: "bold",
        width: 90,
        widthProgress: "186px",
        countColor: "black",
        columnGap: 14,
        starSize: 20,
        heightProgress: "8px",
        scoreFontSize: 2,
        pointerNone: true
      }));
    },
    name: "list-radio"
  }));
};
SelectByRating.defaultProps = {
  data: {
    productRating: {
      reviewsByRating: []
    }
  },
  "static": {
    isMobile: false,
    reviewOptions: [],
    title: ''
  },
  structure: {}
};
 false ? 0 : void 0;
SelectByRating.ssr = true;
/* harmony default export */ var SelectByRating_SelectByRating = (SelectByRating);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectByRating/index.js


/***/ }),

/***/ 87920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SelectedFilters_SelectedFilters; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/SelectedFilters.styles.js


var _templateObject, _templateObject2;





var SelectedFilters_styles_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'unset',
    color: 'text.primary',
    fontSize: 2,
    fontWeight: 'medium',
    height: ['auto'],
    lineHeight: 'display',
    noHover: true,
    width: ['auto']
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('primary')(props);
}, stereo_ui_styles_build_esm/* color */.$_, index_esm/* typography */.cp, index_esm/* layout */.bK);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 2,
    fontWeight: 'bold',
    lineHeight: 'display'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/SelectedFilters.js



var _excluded = ["hidden"];










function getUrlFilterTypes(structure) {
  var _structure$route;
  var filters = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.filters) || [];
  return filters.reduce(function (types, filter) {
    return filter.origin === 'url' ? [].concat((0,toConsumableArray/* default */.Z)(types), [filter.type]) : types;
  }, []);
}
function review(_ref) {
  var data = _ref.data;
  if ((data == null ? void 0 : data.type) !== 'review') return data;
  return [{
    label: (data == null ? void 0 : data.selectedMin) && "".concat(data.selectedMin, " estrela").concat(data.selectedMin > 1 ? 's' : ''),
    selected: !!(data == null ? void 0 : data.selectedMin),
    slug: data == null ? void 0 : data.selectedMin,
    type: data == null ? void 0 : data.slug,
    unique: true
  }];
}
function basic(_ref2) {
  var _data$values;
  var data = _ref2.data;
  return (data == null ? void 0 : (_data$values = data.values) == null ? void 0 : _data$values.map(function (value) {
    return (0,esm_extends/* default */.Z)({}, value, {
      type: data == null ? void 0 : data.slug
    });
  })) || data;
}
function getPriceRangeLabel(_ref3) {
  var selectedMin = _ref3.selectedMin,
    selectedMax = _ref3.selectedMax;
  if (selectedMin && selectedMax) {
    return "De ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMin)
    }), " at\xE9 ").concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMax)
    }));
  }
  if (selectedMin) {
    return "A partir de ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMin)
    }));
  }
  if (selectedMax) {
    return "At\xE9 ".concat((0,currencyFormatter/* default */.Z)({
      value: (0,utils_build_esm/* parsePriceFilter */.il)(selectedMax)
    }));
  }
  return '';
}
function price(_ref4) {
  var data = _ref4.data;
  if ((data == null ? void 0 : data.type) !== 'price') return data;
  return [{
    label: getPriceRangeLabel(data),
    selected: !!(data == null ? void 0 : data.selectedMin) || !!(data == null ? void 0 : data.selectedMax),
    selectedMax: data == null ? void 0 : data.selectedMax,
    selectedMin: data == null ? void 0 : data.selectedMin,
    slug: (data == null ? void 0 : data.selectedMin) || (data == null ? void 0 : data.selectedMax),
    type: data == null ? void 0 : data.slug
  }];
}
var plugins = [basic, review, price];
function CloseCircleFilled(_ref5) {
  var onClick = _ref5.onClick;
  return react.createElement(esm/* Icon */.JO$, {
    name: "CloseCircleFilled",
    width: 16,
    height: 16,
    color: "light",
    cursor: "pointer",
    onClick: onClick,
    "data-testid": "CloseCircleFilled"
  });
}
 false ? 0 : void 0;
function SelectedFilters(_ref6) {
  var staticProps = _ref6["static"],
    data = _ref6.data,
    structure = _ref6.structure;
  var urlFilters = getUrlFilterTypes(structure);
  var _staticProps$title = staticProps.title,
    title = _staticProps$title === void 0 ? 'Filtros Selecionados' : _staticProps$title;
  var _ref7 = (data == null ? void 0 : data.search) || {},
    searchFilters = _ref7.filters;
  var filters = (0,react.useMemo)(function () {
    return searchFilters == null ? void 0 : searchFilters.reduce(function (acc, filter) {
      return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(utils_build_esm/* composite.apply */.h$.apply(void 0, plugins)({
        data: filter
      })));
    }, []);
  }, [searchFilters]);
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var query = structure.query;
  var _getSelectedCategoryFilter = function getSelectedCategoryFilter(filter) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'category';
    var selectedSubcategoryFilter = ((filter == null ? void 0 : filter.values) || []).find(function (_ref8) {
      var selected = _ref8.selected;
      return selected;
    });
    if (selectedSubcategoryFilter) return _getSelectedCategoryFilter(selectedSubcategoryFilter, 'subcategory');
    if (type !== 'category') return (0,esm_extends/* default */.Z)({}, filter, {
      type: type
    });
    return null;
  };
  var selectedFilters = filters == null ? void 0 : filters.reduce(function (acc, filter) {
    if ((filter == null ? void 0 : filter.selected) && !urlFilters.includes(filter.type)) {
      if (filter.type === 'category') {
        var selectedSubcategoryFilter = _getSelectedCategoryFilter(filter);
        return [].concat((0,toConsumableArray/* default */.Z)(acc), [(0,esm_extends/* default */.Z)({}, filter, {
          hidden: Boolean(selectedSubcategoryFilter)
        }), selectedSubcategoryFilter]);
      }
      return [].concat((0,toConsumableArray/* default */.Z)(acc), [filter]);
    }
    return acc;
  }, []).filter(Boolean);
  var handleRemoveFilter = function handleRemoveFilter() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = item.type,
      id = item.id,
      slug = item.slug,
      selected = item.selected,
      unique = item.unique,
      selectedMax = item.selectedMax,
      selectedMin = item.selectedMin;
    publish('productlist:filter:remove', item);
    var path = (0,utils_build_esm/* buildFilterUrl */.P2)({
      max: selectedMax,
      min: selectedMin,
      query: query,
      selected: selected,
      structure: structure,
      type: type,
      unique: unique,
      value: id || slug
    });
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  var handleClearFilters = function handleClearFilters() {
    publish('productlist:filter:clean');
    var path = (0,utils_build_esm/* urlCleanSelectedFilters */.Ld)(selectedFilters, query, structure);
    (0,utils_build_esm/* routePush */.dY)({
      path: path,
      spa: true
    });
  };
  if (selectedFilters == null ? void 0 : selectedFilters.length) {
    return react.createElement(Box/* default */.Z, {
      width: [1],
      py: 3,
      px: 2,
      bg: "background.white"
    }, react.createElement(Flex/* default */.Z, {
      p: [2],
      justifyContent: "space-between",
      flexDirection: "columns"
    }, react.createElement(Title, {
      "data-testid": "selected-filters"
    }, title), react.createElement(SelectedFilters_styles_Button, {
      "data-testid": "clean-filter",
      onClick: handleClearFilters
    }, "Limpar filtros")), react.createElement(Flex/* default */.Z, {
      mx: [2],
      flexGrow: 3,
      flexWrap: "wrap"
    }, selectedFilters.map(function (_ref9, position) {
      var hidden = _ref9.hidden,
        filter = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded);
      return !hidden && react.createElement(Chip/* default */.Z, {
        key: "".concat(filter.type, "-").concat(filter.slug),
        type: "checkbox",
        clickable: true,
        autoSize: true,
        bg: "secondary",
        as: "div",
        color: "base",
        m: 1,
        endIcon: react.createElement(CloseCircleFilled, {
          onClick: function onClick() {
            return handleRemoveFilter((0,esm_extends/* default */.Z)({}, filter, {
              position: position
            }));
          }
        })
      }, filter.label);
    })));
  }
  return null;
}
SelectedFilters.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
 false ? 0 : void 0;
/* harmony default export */ var SelectedFilters_SelectedFilters = (SelectedFilters);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectedFilters/index.js


/***/ }),

/***/ 97172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SelectionCouponCard_SelectionCouponCard; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CouponCard/index.js + 2 modules
var CouponCard = __webpack_require__(704);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/utils.js
var findCouponTag = function findCouponTag(tags) {
  if (!tags) return null;
  return tags.find(function (tag) {
    return tag.type === 'coupon';
  });
};
var findProductWithCoupon = function findProductWithCoupon(products) {
  if (!products) return null;
  return products.find(function (product) {
    var _product$seller;
    return findCouponTag((_product$seller = product.seller) == null ? void 0 : _product$seller.tags);
  });
};
var formattedDate = function formattedDate(date) {
  if (!date) return null;
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short'
  });
};
var getCouponInfo = function getCouponInfo(product) {
  var _findCouponTag = findCouponTag(product.seller.tags),
    code = _findCouponTag.code,
    discountType = _findCouponTag.discountType,
    discountValue = _findCouponTag.discountValue;
  return {
    code: code,
    discountType: discountType,
    discountValue: discountValue
  };
};
var isValidDate = function isValidDate(date) {
  var parsedDate = new Date(date * 1000);
  return {
    isValid: !Number.isNaN(parsedDate.getTime()) && parsedDate >= new Date(),
    parsedDate: parsedDate
  };
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/SelectionCouponCard.js








var SelectionCouponCard = function SelectionCouponCard(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var title = staticProps.title,
    products = staticProps.products,
    endDate = staticProps.endDate,
    type = staticProps.type;
  var isCouponType = type === 'coupon';
  var productWithCoupon = findProductWithCoupon(products);
  var isValidEndDate = isValidDate(endDate);
  if (!productWithCoupon || !isValidEndDate || !isCouponType) return null;
  var _ref2 = getCouponInfo(productWithCoupon) || {},
    code = _ref2.code,
    discountType = _ref2.discountType,
    discountValue = _ref2.discountValue;
  var handleView = function handleView() {
    publish('coupon:viewItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  var handleClick = function handleClick() {
    publish('coupon:selectItem', {
      couponName: code,
      screenName: structure == null ? void 0 : structure.name,
      sectionTitle: title
    });
  };
  (0,react.useEffect)(function () {
    handleView();
  }, []);
  return react.createElement(CouponCard/* default */.Z, (0,esm_extends/* default */.Z)({
    headerText: title
  }, staticProps), react.createElement(molecules/* CouponCodeCopy */.F7, {
    code: code.toUpperCase(),
    discountType: discountType,
    discountValue: discountValue,
    expirationDate: formattedDate(isValidEndDate == null ? void 0 : isValidEndDate.parsedDate),
    auxiliaryText: "Copie o cupom e cole na revis\xE3o. V\xE1lido at\xE9",
    onCopySuccess: handleClick
  }));
};
 false ? 0 : void 0;
SelectionCouponCard.defaultProps = {
  "static": {},
  structure: {}
};
SelectionCouponCard.ssr = false;
SelectionCouponCard.displayName = 'SelectionCouponCard';
/* harmony default export */ var SelectionCouponCard_SelectionCouponCard = ((0,withLayoutProps/* default */.Z)(SelectionCouponCard));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SelectionCouponCard/index.js


/***/ }),

/***/ 57797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerDelivery_SellerDelivery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var organisms_SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDelivery/SellerDelivery.js






var SellerDelivery = function SellerDelivery(_ref) {
  var product = _ref.data.product,
    _ref$static = _ref["static"],
    href = _ref$static.href,
    spa = _ref$static.spa,
    disableSellerClick = _ref$static.disableSellerClick,
    showDialog = _ref$static.showDialog,
    logoIconColor = _ref$static.logoIconColor;
  var _ref2 = product || {},
    seller = _ref2.seller;
  var path = "".concat(href).concat(seller == null ? void 0 : seller.id, "/");
  var props = {
    disableSellerClick: disableSellerClick,
    seller: (0,esm_extends/* default */.Z)({}, seller, {
      href: path
    }),
    showDialog: showDialog
  };
  var onOffersClick = function onOffersClick(e) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: path,
      spa: spa
    });
  };
  if (spa) {
    props.onOffersClick = onOffersClick;
  }
  return react.createElement(organisms_SellerDelivery/* default */.Z, (0,esm_extends/* default */.Z)({
    logoIconColor: logoIconColor
  }, props));
};
 false ? 0 : void 0;
SellerDelivery.defaultProps = {
  data: {},
  "static": {
    href: '',
    logoIconColor: '',
    showDialog: false,
    spa: false
  }
};
SellerDelivery.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
SellerDelivery.ssr = true;
/* harmony default export */ var SellerDelivery_SellerDelivery = ((0,withLayoutProps/* default */.Z)(SellerDelivery));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDelivery/index.js


/***/ }),

/***/ 2719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalContent_ModalContent; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/commons/masks/cnpjMask.js
var cnpjMask = __webpack_require__(17370);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js + 2 modules
var SellerScore = __webpack_require__(3716);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/constants.js
var ScoreDetailsTexts = [{
  description: 'Pedidos que foram despachados e entregues no prazo previsto.',
  icon: 'DeliveryDefault',
  title: 'Pedidos entregues no prazo'
}, {
  description: 'Total de cancelamentos de pedidos solicitados pelos clientes ou por essa loja por diferentes motivos: falta de peças, produto com avarias, produto diferente ou pelo recebimento fora do prazo.',
  icon: 'PackageAlert',
  title: 'Cancelamentos'
}, {
  description: 'Avalia o tempo que a loja leva para responder aos clientes nos canais de atendimento: Protocolo, Chat com o Cliente e Perguntas e Respostas',
  icon: 'CustomerContact',
  title: 'Agilidade no atendimento'
}];
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/ScoreDetails.styles.js

var _templateObject;



var ShowDetails = styled_components_browser_esm/* default.button */.ZP.button(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  text-transform: none;\n  width: 100%;\n  justify-content: space-between;\n  margin-top: ", "px;\n  padding: ", "px;\n  color: ", ";\n  font-size: ", "px;\n  border-radius: ", ";\n  font-weight: ", ";\n  background-color: ", ";\n  border: ", ";\n  cursor: pointer;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.2')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('attributeLabel')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.1')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.default')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.regular')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.transparent')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('borders.0')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ScoreDetails/ScoreDetails.js









var ScoreDetailsContent = function ScoreDetailsContent() {
  return react.createElement(atoms/* Box */.xu, {
    "data-testid": "score-details-content",
    p: [3, 0]
  }, react.createElement(atoms/* Text */.xv, {
    mt: 2,
    mb: 2,
    fontWeight: "regular"
  }, "A nota de reputa\xE7\xE3o refere-se a v\xE1rios crit\xE9rios na experi\xEAncia de compra oferecida aos clientes. Saiba o que levamos a considera\xE7\xE3o."), ScoreDetailsTexts.map(function (_ref) {
    var description = _ref.description,
      icon = _ref.icon,
      title = _ref.title;
    return react.createElement(atoms/* Grid */.rj, {
      key: icon,
      gridAutoFlow: "column",
      gap: 2,
      py: 12
    }, react.createElement(esm/* Icon */.JO$, {
      fill: "background.primary",
      name: icon,
      width: 33,
      height: 30
    }), react.createElement(atoms/* Box */.xu, null, react.createElement(atoms/* Text */.xv, {
      fontWeight: "bold",
      fontSize: [3, 2]
    }, title), react.createElement(atoms/* Text */.xv, {
      mt: 2,
      fontSize: [1, 0]
    }, description)));
  }));
};
function ScoreDetails(_ref2) {
  var seller = _ref2.seller,
    _ref2$static = _ref2["static"],
    scoreDetailsTitle = _ref2$static.scoreDetailsTitle,
    scoreDetailsSidebar = _ref2$static.scoreDetailsSidebar,
    isMobile = _ref2.isMobile;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showScoreDetail = _useState2[0],
    setShowScoreDetails = _useState2[1];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var eventPublish = function eventPublish() {
    return publish('sellerdetails:click:about:rating', {
      seller: seller
    });
  };
  var handleShowDetails = function handleShowDetails() {
    eventPublish();
    setShowScoreDetails(true);
  };
  return isMobile ? react.createElement(react.Fragment, null, react.createElement(ShowDetails, {
    full: true,
    mt: 3,
    mb: 3,
    "data-testid": "showScoreDetails",
    onClick: handleShowDetails
  }, scoreDetailsTitle, react.createElement(esm/* Icon */.JO$, {
    name: "ChevronRight",
    fill: "background.primary"
  })), react.createElement(organisms/* Sidebar */.YE, {
    direction: "right",
    visible: showScoreDetail,
    fullScreen: true,
    title: scoreDetailsSidebar,
    "data-testid": "ScoreSidebar"
  }, react.createElement(organisms/* Sidebar.Header */.YE.Header, {
    startIcon: "ArrowBack",
    onClick: function onClick() {
      return setShowScoreDetails(false);
    }
  }, scoreDetailsSidebar), react.createElement(ScoreDetailsContent, null))) : react.createElement(atoms/* Box */.xu, {
    "data-testid": "score-details-accordion",
    maxWidth: "340px"
  }, react.createElement(atoms/* Box */.xu, {
    mt: 3
  }, react.createElement(atoms/* HorizontalRule */.bo, null)), react.createElement(atoms/* Accordion */.UQ, {
    closeIcon: "ChevronUp",
    title: scoreDetailsTitle,
    open: showScoreDetail,
    onClick: function onClick() {
      setShowScoreDetails(!showScoreDetail);
      eventPublish();
    },
    fontWeight: "regular",
    openIcon: "ChevronDown"
  }, react.createElement(ScoreDetailsContent, null)), react.createElement(atoms/* Box */.xu, {
    mb: 3
  }, react.createElement(atoms/* HorizontalRule */.bo, null)));
}
ScoreDetails.defaultProps = {
  isMobile: false,
  seller: '',
  "static": {
    scoreDetailsSidebar: '',
    scoreDetailsTitle: ''
  }
};
 false ? 0 : void 0;
/* harmony default export */ var ScoreDetails_ScoreDetails = (ScoreDetails);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var stereo_ui_build_esm = __webpack_require__(87302);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/GuaranteeText/SellerGuaranteeText.js



var SellerGuaranteeText = function SellerGuaranteeText(_ref) {
  var isMagaluCompany = _ref.isMagaluCompany;
  var getTextIntro = function getTextIntro() {
    return isMagaluCompany ? 'Este produto é vendido por uma empresa do grupo Magalu' : 'Este produto é vendido por um lojista parceiro';
  };
  var getTextBody = function getTextBody() {
    return isMagaluCompany ? 'Todas as empresas do nosso ecossistema compartilham do mesmo propósito, oferecendo uma experiência diferenciada.' : 'Nossos parceiros são selecionados e avaliados por critérios de excelência no serviço.';
  };
  return react.createElement(stereo_ui_build_esm/* Text */.xvT, {
    fontSize: 1,
    fontWeight: "regular",
    color: "attributeLabel",
    lineHeight: "16px",
    "data-testid": "GuaranteeText"
  }, getTextIntro(), "\xA0e o\xA0", react.createElement(stereo_ui_build_esm/* Text */.xvT, {
    as: "span",
    fontWeight: "bold"
  }, "Magalu garante a entrega.\xA0"), getTextBody(), "\xA0Certificamos as vendas com nota fiscal e garantimos produtos originais. Se tem no Magalu, t\xE1 garantido!");
};
SellerGuaranteeText.defaultProps = {
  isMagaluCompany: false
};
 false ? 0 : void 0;
/* harmony default export */ var GuaranteeText_SellerGuaranteeText = (SellerGuaranteeText);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/GuaranteeText/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.utils.js

var getFormattedSellerAddress = function getFormattedSellerAddress() {
  var addressDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _addressDetails$addre = addressDetails.address,
    addressInfo = _addressDetails$addre === void 0 ? {} : _addressDetails$addre;
  var address = addressInfo.address,
    number = addressInfo.number,
    city = addressInfo.city,
    state = addressInfo.state,
    district = addressInfo.district,
    zipcode = addressInfo.zipcode;
  var formattedAddress = [];
  if (address && number) {
    formattedAddress.push("".concat(address, ", ").concat(number));
  }
  if (city && state) {
    var formatedDistrict = district ? "".concat(district, " - ") : '';
    formattedAddress.push("".concat(formatedDistrict).concat(city, "/").concat(state));
  }
  if (zipcode) {
    formattedAddress.push((0,stereo_ui_build_esm/* zipcodeMask */.CKO)(zipcode));
  }
  return formattedAddress;
};
var regulatoryData = function regulatoryData(regulatoryType, data) {
  if (data) return !data[regulatoryType].notApply;
  return null;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.styles.js

var ModalContent_styles_templateObject, _templateObject2, _templateObject3, _templateObject4;




var DataInfo = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs({
  color: 'attributeLabel',
  fontSize: 1
})(ModalContent_styles_templateObject || (ModalContent_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 16px;\n"])));
var DataTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs({
  color: 'attributeLabel',
  fontSize: [2, 1],
  fontWeight: 'bold',
  lineHeight: 1.2
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Hr = (0,styled_components_browser_esm/* default */.ZP)(atoms/* HorizontalRule */.bo)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 24px 0;\n  background-color: ", ";\n"])), function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.darker')(props);
});
var Offers = styled_components_browser_esm/* default.a */.ZP.a(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  margin: 0 auto 0 auto;\n  width: fit-content;\n  padding: ", "px;\n  color: ", ";\n  font-size: ", "px;\n  border-radius: ", ";\n  font-weight: ", ";\n  background-color: ", ";\n  padding-left: 13px;\n  cursor: pointer;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.1')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* getTextColor */.uu)('primary')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.2')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.default')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.bold')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.darker')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.js












function ModalContent(_ref) {
  var _details$regulatoryDa, _details$regulatoryDa2, _seller$details;
  var seller = _ref.seller,
    product = _ref.product,
    scoreDetailsTitle = _ref.scoreDetailsTitle,
    scoreDetailsSidebar = _ref.scoreDetailsSidebar,
    showDialog = _ref.showDialog,
    spa = _ref.spa,
    href = _ref.href;
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var details = seller.details;
  var path = "".concat(href).concat(seller == null ? void 0 : seller.id, "/");
  var magaluCompany = build_esm/* magaluCompanies */.p5[seller == null ? void 0 : seller.id];
  var isMagaluCompany = !!magaluCompany;
  var showInternationalSeller = (0,build_esm/* isInternationalPrice */.xx)(product);
  var docSeller = function docSeller() {
    return !showInternationalSeller ? {
      label: 'CNPJ',
      value: (0,cnpjMask/* default */.Z)(details == null ? void 0 : details.documentNumber)
    } : {
      label: 'ID do Lojista',
      value: details == null ? void 0 : details.shippingDocumentNumber
    };
  };
  var detailsSections = [docSeller(), (details == null ? void 0 : details.legalName) && {
    label: 'Razão Social',
    value: details.legalName
  }, (details == null ? void 0 : details.address) && {
    label: 'Endereço',
    value: getFormattedSellerAddress(details).map(function (text) {
      return react.createElement(DataInfo, {
        key: text
      }, text);
    })
  }, regulatoryData('anvisa', details == null ? void 0 : details.regulatoryData) && {
    label: 'Autorização ANVISA',
    value: details == null ? void 0 : (_details$regulatoryDa = details.regulatoryData) == null ? void 0 : _details$regulatoryDa.anvisa.items.map(function (item) {
      return react.createElement("span", {
        key: item
      }, item);
    })
  }, regulatoryData('mapa', details == null ? void 0 : details.regulatoryData) && {
    label: 'Autorização MAPA',
    value: details == null ? void 0 : (_details$regulatoryDa2 = details.regulatoryData) == null ? void 0 : _details$regulatoryDa2.mapa.items.map(function (item) {
      return react.createElement("span", {
        key: item
      }, item);
    })
  }];
  var onOffersClick = function onOffersClick(e) {
    publish('sellerdetails:offers:link:click', {
      seller: seller
    });
    if (spa) {
      e.preventDefault();
      (0,build_esm/* routePush */.dY)({
        path: path,
        spa: spa
      });
    }
  };
  return react.createElement(atoms/* Box */.xu, {
    p: !showDialog ? 3 : undefined,
    "data-testid": "seller-modal-content"
  }, !showDialog && react.createElement(atoms/* Text */.xv, {
    fontWeight: "bold",
    color: "attributeLabel",
    fontSize: 4,
    mb: 4
  }, "Informa\xE7\xF5es da loja parceira"), react.createElement(SellerScore/* default */.Z, {
    "static": {
      isMagaluCompany: isMagaluCompany,
      seller: seller
    }
  }), ((_seller$details = seller.details) == null ? void 0 : _seller$details.score) && !isMagaluCompany && react.createElement(ScoreDetails_ScoreDetails, {
    "static": {
      scoreDetailsSidebar: scoreDetailsSidebar,
      scoreDetailsTitle: scoreDetailsTitle
    },
    isMobile: !showDialog,
    seller: seller
  }), react.createElement(atoms/* Grid */.rj, {
    gridAutoFlow: "column",
    gap: 2,
    py: 24
  }, react.createElement(esm/* Icon */.JO$, {
    name: "Guarantee",
    width: 33,
    height: 30
  }), react.createElement(atoms/* Box */.xu, {
    width: showDialog ? 300 : undefined
  }, !showInternationalSeller && react.createElement(GuaranteeText_SellerGuaranteeText, {
    isMagaluCompany: isMagaluCompany
  }), showInternationalSeller && react.createElement(atoms/* Text */.xv, {
    fontSize: 1,
    fontWeight: "regular",
    color: "attributeLabel",
    lineHeight: "16px",
    "data-testid": "GuaranteeText"
  }, "O Magalu garante a sua compra, do pedido \xE0 entrega."))), react.createElement(Offers, {
    href: path,
    onClick: onOffersClick,
    "data-testid": "offers-link"
  }, "Ver mais produtos da loja", react.createElement(esm/* Icon */.JO$, {
    color: "background.magablu",
    name: "ChevronRight",
    ml: 2
  })), react.createElement(Hr, null), react.createElement(atoms/* Flex */.kC, {
    gap: 3,
    flexDirection: "column"
  }, details && detailsSections.filter(function (value) {
    return !!value;
  }).map(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      label = _ref2.label,
      value = _ref2.value;
    return react.createElement(atoms/* Box */.xu, {
      key: label
    }, react.createElement(DataTitle, null, label), react.createElement(DataInfo, null, value));
  })));
}
ModalContent.defaultProps = {
  href: '',
  product: {},
  scoreDetailsSidebar: '',
  scoreDetailsTitle: '',
  seller: {
    description: '',
    details: {
      address: {}
    },
    id: ''
  },
  showDialog: false,
  spa: false
};
 false ? 0 : void 0;
ModalContent.ssr = true;
/* harmony default export */ var ModalContent_ModalContent = (ModalContent);

/***/ }),

/***/ 87487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerDetails_SellerDetails; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/ModalContent.js + 7 modules
var ModalContent = __webpack_require__(2719);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/ModalContent/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/SellerDetails.js









var SellerDetails = function SellerDetails(_ref) {
  var product = _ref.data.product,
    _ref$static = _ref["static"],
    _ref$static$disableSe = _ref$static.disableSellerClick,
    disableSellerClick = _ref$static$disableSe === void 0 ? false : _ref$static$disableSe,
    href = _ref$static.href,
    logoIconColor = _ref$static.logoIconColor,
    scoreDetailsTitle = _ref$static.scoreDetailsTitle,
    scoreDetailsSidebar = _ref$static.scoreDetailsSidebar,
    showDialog = _ref$static.showDialog,
    spa = _ref$static.spa;
  var eventName = 'sellershowdetail:open';
  var seller = product.seller,
    variationId = product.variationId;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe,
    publish = _usePublisher.publish;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showSellerDetailContent = _useState2[0],
    setShowSellerDetailContent = _useState2[1];
  var handleShowDialog = function handleShowDialog() {
    return setShowSellerDetailContent(true);
  };
  var handleCloseDialog = function handleCloseDialog() {
    return setShowSellerDetailContent(false);
  };
  (0,react.useEffect)(function () {
    subscribe(eventName, handleShowDialog);
    return function () {
      unsubscribe(eventName, handleShowDialog);
    };
  });
  var internationalPartner = build_esm/* internationalPartners */.JS[seller.id];
  var internationalPartnerProps = internationalPartner ? {
    internationalPartner: true,
    partnerColor: internationalPartner.color,
    partnerLogo: internationalPartner.logo
  } : {};
  var props = (0,esm_extends/* default */.Z)({
    disableSellerClick: disableSellerClick,
    href: href,
    onCloseModalContent: handleCloseDialog,
    product: product,
    scoreDetailsSidebar: scoreDetailsSidebar,
    scoreDetailsTitle: scoreDetailsTitle,
    seller: seller,
    showDialog: showDialog,
    showSellerDetailContent: showSellerDetailContent,
    spa: spa
  }, internationalPartnerProps);
  var handleSellerClick = function handleSellerClick() {
    publish('sellerdetails:open:modal:click', {
      seller: seller,
      variationId: variationId
    });
    publish(eventName);
  };
  return react.createElement(SellerDelivery/* default */.Z, (0,esm_extends/* default */.Z)({
    logoIconColor: logoIconColor,
    onSellerClick: handleSellerClick,
    modal: {
      content: react.createElement(ModalContent/* default */.Z, props),
      title: 'Informações da loja parceira',
      titleStyle: {
        color: 'attributeLabel',
        fontWeight: 'bold',
        pl: 0
      }
    }
  }, props));
};
 false ? 0 : void 0;
SellerDetails.defaultProps = {
  data: {
    product: {}
  },
  "static": {
    href: '',
    logoIconColor: '',
    scoreDetailsSidebar: '',
    scoreDetailsTitle: '',
    showDialog: false,
    spa: false
  }
};
SellerDetails.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
SellerDetails.ssr = true;
/* harmony default export */ var SellerDetails_SellerDetails = ((0,withLayoutProps/* default */.Z)(SellerDetails));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerDetails/index.js


/***/ }),

/***/ 3716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SellerScore_SellerScore; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/index.js
var esm = __webpack_require__(87302);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerStamp/SellerStamp.js
var SellerStamp = __webpack_require__(25782);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.utils.js

var getMinimumScoreToShow = function getMinimumScoreToShow() {
  var SHOW_SELLER_SCORE_ABOVE = build_esm/* cookiesConstants.SHOW_SELLER_SCORE_ABOVE */.VD.SHOW_SELLER_SCORE_ABOVE;
  var cookieValue = (0,build_esm/* getCookie */.ej)(SHOW_SELLER_SCORE_ABOVE);
  try {
    var parsedValue = Number(cookieValue);
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
  } catch (_unused) {
    return 0;
  }
};
var getSalesLabel = function getSalesLabel(value) {
  var _findLabels$label;
  var labels = [{
    label: '+1 milhão',
    limit: 1000000
  }, {
    label: '+500mil',
    limit: 500000
  }, {
    label: '+200mil',
    limit: 200000
  }, {
    label: '+100mil',
    limit: 100000
  }, {
    label: '+50mil',
    limit: 50000
  }, {
    label: '+20mil',
    limit: 20000
  }, {
    label: '+10mil',
    limit: 10000
  }, {
    label: '+5mil',
    limit: 5000
  }, {
    label: '+1mil',
    limit: 1000
  }, {
    label: '+500',
    limit: 500
  }, {
    label: '+200',
    limit: 200
  }, {
    label: '+100',
    limit: 100
  }, {
    label: '+50',
    limit: 50
  }, {
    label: '+10',
    limit: 10
  }];
  var findLabels = labels.find(function (faixa) {
    return value >= faixa.limit;
  });
  return (_findLabels$label = findLabels == null ? void 0 : findLabels.label) !== null && _findLabels$label !== void 0 ? _findLabels$label : '';
};
var getSellerRole = function getSellerRole(isMagaluCompany, seller) {
  var _seller$details, _seller$details2, _seller$details3;
  var isNewSeller = (seller == null ? void 0 : (_seller$details = seller.details) == null ? void 0 : _seller$details.score) === null;
  var sellerSince = seller == null ? void 0 : (_seller$details2 = seller.details) == null ? void 0 : _seller$details2.sellerSince;
  var isDocShipping = seller == null ? void 0 : (_seller$details3 = seller.details) == null ? void 0 : _seller$details3.shippingDocumentNumber;
  var sellerYear = sellerSince == null ? void 0 : sellerSince.substr(0, 4);
  if (!isMagaluCompany) {
    if (isNewSeller || !sellerYear) {
      return 'Lojista Magalu';
    }
    return "Lojista Magalu desde ".concat(sellerYear);
  }
  if (isMagaluCompany && isDocShipping) {
    return 'Loja parceiro internacional';
  }
  return 'Loja do grupo Magalu';
};
var handleScoreColor = function handleScoreColor(score) {
  var defaultColor = '#B8C1C4';
  var scoreRanges = [{
    color: defaultColor,
    max: 0
  }, {
    color: '#E3172C',
    max: 1.49
  }, {
    color: '#FD8A25',
    max: 1.99
  }, {
    color: '#EEB510',
    max: 2.49
  }, {
    color: '#F9C52E',
    max: 2.99
  }, {
    color: '#5EBE09',
    max: 3.99
  }, {
    color: '#4EA900',
    max: 5
  }];
  var range = scoreRanges.find(function (_ref) {
    var max = _ref.max;
    return score <= max;
  });
  return range ? range.color : defaultColor;
};

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.styles.js

var _templateObject, _templateObject2;



var IconContainer = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xuv)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  height: 64px;\n"])));
var NewSellerBadge = (0,styled_components_browser_esm/* default */.ZP)(esm/* Text */.xvT).attrs({
  bg: 'background.primary',
  borderRadius: 'small',
  color: 'white',
  fontSize: 1,
  p: 1
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.default')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js








var MAX_PROGRESS_BAR = 100;
var MAX_SCORE = 5;
var SCORE_VALUE_SCALE = MAX_PROGRESS_BAR / MAX_SCORE;
function SellerScore(_ref) {
  var _seller$details, _magaluCompanies$sell, _seller$details2, _seller$details2$deli, _seller$details3, _seller$details3$deli, _seller$details4, _seller$details4$answ, _seller$details5, _seller$details5$answ, _seller$details6, _seller$details7, _seller$details8, _seller$details9, _seller$details10;
  var _ref$static = _ref["static"],
    isMagaluCompany = _ref$static.isMagaluCompany,
    seller = _ref$static.seller;
  var isNewSeller = (seller == null ? void 0 : (_seller$details = seller.details) == null ? void 0 : _seller$details.score) === null;
  var sellerRole = getSellerRole(isMagaluCompany, seller);
  var sellerIcon = isMagaluCompany ? (_magaluCompanies$sell = build_esm/* magaluCompanies */.p5[seller.id]) == null ? void 0 : _magaluCompanies$sell.icon : 'https://wx.mlcdn.com.br/site/shared/sellers/third-party.png';
  var labelText = ['Ruim', 'Ótimo'];
  var minimumScoreToShow = getMinimumScoreToShow();
  var getScoreLabel = function getScoreLabel(score) {
    if (score.toFixed(2) <= minimumScoreToShow) return '';
    return "".concat(score.toFixed(2)).substring(0, 3);
  };
  var deliveryRateStatus = seller == null ? void 0 : (_seller$details2 = seller.details) == null ? void 0 : (_seller$details2$deli = _seller$details2.deliveryRate) == null ? void 0 : _seller$details2$deli.status;
  var deliveryRateMessage = seller == null ? void 0 : (_seller$details3 = seller.details) == null ? void 0 : (_seller$details3$deli = _seller$details3.deliveryRate) == null ? void 0 : _seller$details3$deli.message;
  var answerRateStatus = seller == null ? void 0 : (_seller$details4 = seller.details) == null ? void 0 : (_seller$details4$answ = _seller$details4.answerRate) == null ? void 0 : _seller$details4$answ.status;
  var answerRateMessage = seller == null ? void 0 : (_seller$details5 = seller.details) == null ? void 0 : (_seller$details5$answ = _seller$details5.answerRate) == null ? void 0 : _seller$details5$answ.message;
  var sellerTotalSales = seller == null ? void 0 : (_seller$details6 = seller.details) == null ? void 0 : _seller$details6.totalSales;
  var getDeliveryIcon = function getDeliveryIcon() {
    var icons = {
      success: 'DeliverySuccess',
      warning: 'DeliveryWarning'
    };
    return icons[deliveryRateStatus] || 'DeliveryDefault';
  };
  var getAnswerIcon = function getAnswerIcon() {
    var icons = {
      success: 'ChatSuccess',
      warning: 'ChatWarning'
    };
    return icons[answerRateStatus] || 'Chat';
  };
  return react.createElement(esm/* Box */.xuv, null, react.createElement(esm/* Flex */.kCb, {
    gap: 3,
    height: 64,
    mb: isNewSeller && !isMagaluCompany && 10
  }, sellerIcon && react.createElement(IconContainer, null, react.createElement(esm/* Image */.Eep, {
    src: sellerIcon,
    imageWidth: 64,
    imageHeight: 64,
    alt: seller.description,
    "data-testid": "seller-icon"
  }), isNewSeller && !isMagaluCompany && react.createElement(NewSellerBadge, {
    "data-testid": "new-seller"
  }, "Novo")), react.createElement(esm/* Flex */.kCb, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    lineHeight: 1,
    gap: 1
  }, react.createElement(esm/* Heading */.X6q, {
    color: "attributeLabel",
    fontWeight: "medium",
    lineHeight: "input",
    fontSize: 3
  }, seller.description), react.createElement(esm/* Text */.xvT, {
    color: "attributeLabel",
    textAlign: "left",
    fontWeight: "regular",
    "data-testid": "seller-role",
    fontSize: 2
  }, sellerRole))), ((_seller$details7 = seller.details) == null ? void 0 : _seller$details7.score) && !isMagaluCompany && react.createElement(esm/* Box */.xuv, {
    pt: 26,
    mt: 1,
    flexDirection: "column"
  }, react.createElement(esm/* LinearProgress */.ukE, {
    max: 100,
    height: "16px",
    value: ((_seller$details8 = seller.details) == null ? void 0 : _seller$details8.score) * SCORE_VALUE_SCALE,
    label: getScoreLabel((_seller$details9 = seller.details) == null ? void 0 : _seller$details9.score),
    color: handleScoreColor((_seller$details10 = seller.details) == null ? void 0 : _seller$details10.score),
    bullets: {
      quantity: 5,
      size: 6
    }
  }), react.createElement(esm/* Flex */.kCb, {
    px: 3,
    pt: 1,
    mt: 1,
    justifyContent: "space-between",
    fontWeight: "regular",
    fontSize: 0
  }, labelText == null ? void 0 : labelText.map(function (item) {
    return react.createElement(esm/* Text */.xvT, {
      key: "label-".concat(item),
      color: "#697277"
    }, item);
  })), !isNewSeller && react.createElement(esm/* Flex */.kCb, {
    "data-testid": "seller-stamps"
  }, !!sellerTotalSales && react.createElement(SellerStamp/* default */.Z, {
    iconName: "TotalSales",
    iconDataTestId: "salesIcon",
    title: getSalesLabel(sellerTotalSales),
    message: "Produtos vendidos"
  }), !!deliveryRateMessage && react.createElement(SellerStamp/* default */.Z, {
    iconName: getDeliveryIcon(),
    iconDataTestId: "delivery-".concat(deliveryRateStatus),
    title: "Entrega",
    message: deliveryRateMessage
  }), !!answerRateMessage && react.createElement(SellerStamp/* default */.Z, {
    iconName: getAnswerIcon(),
    iconDataTestId: "answer-".concat(answerRateStatus),
    title: "Atendimento",
    message: answerRateMessage
  }))));
}
SellerScore.defaultProps = {
  "static": {
    isMagaluCompany: false,
    seller: {
      description: '',
      details: {},
      id: ''
    }
  }
};
 false ? 0 : void 0;
SellerScore.ssr = true;
/* harmony default export */ var SellerScore_SellerScore = ((0,withLayoutProps/* default */.Z)(SellerScore));

/***/ }),

/***/ 25782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87302);
/* harmony import */ var _magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34490);
/* harmony import */ var _hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89382);


var _excluded = ["title", "iconDataTestId", "message", "iconName"];





function SellerStamp(_ref) {
  var title = _ref.title,
    iconDataTestId = _ref.iconDataTestId,
    message = _ref.message,
    iconName = _ref.iconName,
    props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    width: 1,
    height: 70,
    mt: 3
  }, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
    columnGap: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "data-testid": "text-container"
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_icons__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO$, {
    name: iconName,
    "data-testid": iconDataTestId,
    width: 32,
    height: 32
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
    pb: 1,
    pt: 2,
    fontWeight: "bold",
    fontSize: 16,
    lineHeight: 1
  }, title), react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
    fontSize: "10px",
    lineHeight: 1
  }, message)));
}
SellerStamp.defaultProps = {
  iconDataTestId: '',
  message: '',
  title: ''
};
 false ? 0 : void 0;
SellerStamp.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SellerStamp));

/***/ }),

/***/ 54097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SellerStamp__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _SellerStamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25782);


/***/ }),

/***/ 7202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SellerStoreInfo_SellerStoreInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js
var objectDestructuringEmpty = __webpack_require__(33665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/SellerScore/SellerScore.js + 2 modules
var SellerScore = __webpack_require__(3716);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/SellerStoreInfo.styles.js


var _templateObject, _templateObject2;




var Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    pt: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-bottom: 3px solid ", ";\n  border-top: 3px solid ", ";\n\n  ", " {\n    border-top: none;\n    border-bottom: 1px solid ", ";\n  }\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* getBorderColor */.kJ)('light')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* getBorderColor */.kJ)('light')(props);
}, (0,utils/* getMediaQuery */.aK)('small'), function (props) {
  return (0,stereo_ui_styles_build_esm/* getBorderColor */.kJ)('light')(props);
});
var SellerDetailsStore = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(function () {
  return {
    color: 'primary',
    fontWeight: 'medium',
    my: [24, 18],
    px: 2,
    py: 1
  };
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  cursor: pointer;\n\n  ", " {\n    justify-content: flex-start;\n  }\n"])), (0,utils/* getMediaQuery */.aK)('small'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/SellerStoreInfo.js










var SellerStoreInfo = function SellerStoreInfo(_ref) {
  var product = _ref.data.product,
    props = (0,esm_extends/* default */.Z)({}, ((0,objectDestructuringEmpty/* default */.Z)(_ref["static"]), _ref["static"]));
  var seller = product.seller;
  var magaluCompany = utils_build_esm/* magaluCompanies */.p5[seller == null ? void 0 : seller.id];
  var isMagaluCompany = !!magaluCompany;
  var isMagalu = seller.category === '1p';
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  react.useEffect(function () {
    if (!isMagaluCompany && !isMagalu) {
      publish('sellerdetails:impression', {
        seller: seller
      });
    }
  }, []);
  var onSellerDetailsClick = function onSellerDetailsClick() {
    publish('sellerdetailspdp:open:modal:click', {
      seller: seller
    });
    publish('sellershowdetail:open');
  };
  return !isMagalu && (seller == null ? void 0 : seller.id) && react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "seller-modal-content"
  }, props), react.createElement(atoms/* Text */.xv, {
    fontWeight: "bold",
    color: "attributeLabel",
    fontSize: 3,
    mb: 3
  }, "Informa\xE7\xF5es da Loja"), react.createElement(SellerScore/* default */.Z, {
    "static": {
      isMagaluCompany: isMagaluCompany,
      seller: seller
    }
  }), react.createElement(SellerDetailsStore, {
    role: "button",
    fontSize: [2, 1],
    onClick: onSellerDetailsClick,
    "data-testid": "sellerDetailsStore-link",
    mx: [0, 0, 'auto']
  }, "Ver mais informa\xE7\xF5es da loja", react.createElement(esm/* Icon */.JO$, {
    color: "background.magablu",
    name: "ChevronRight",
    ml: 2
  })));
};
SellerStoreInfo.defaultProps = {
  data: {
    product: {
      seller: {
        category: '',
        description: '',
        id: ''
      }
    }
  },
  "static": {}
};
 false ? 0 : void 0;
SellerStoreInfo.ssr = true;
/* harmony default export */ var SellerStoreInfo_SellerStoreInfo = (SellerStoreInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SellerStoreInfo/index.js


/***/ }),

/***/ 18779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoLinkList_SeoLinkList; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js + 2 modules
var TextList = __webpack_require__(35306);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/SeoLinkList.js


var _excluded = ["title", "terms"];





var SeoLinkList = function SeoLinkList(_ref) {
  var staticProps = _ref["static"];
  var title = staticProps.title,
    terms = staticProps.terms,
    props = (0,objectWithoutProperties/* default */.Z)(staticProps, _excluded);
  var renderItems = terms.map(function (item) {
    return [{
      href: item.href,
      value: item.value
    }];
  });
  var onLinkClick = function onLinkClick(e, _ref2) {
    var href = _ref2.href;
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  return react.createElement(TextList/* default */.Z, (0,esm_extends/* default */.Z)({
    handleClickLink: onLinkClick,
    list: renderItems,
    title: title,
    titleAs: "h2",
    typeList: "inline"
  }, props));
};
SeoLinkList.ssr = true;
 false ? 0 : void 0;
SeoLinkList.defaultProps = {
  "static": {}
};
/* harmony default export */ var SeoLinkList_SeoLinkList = ((0,withLayoutProps/* default */.Z)(SeoLinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoLinkList/index.js


/***/ }),

/***/ 23508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoRelatedLinkList_SeoRelatedLinkList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/SeoRelatedLinkList.styles.js

var _templateObject, _templateObject2;


var SeoRelatedLinkList_styles_List = (0,styled_components_browser_esm/* default */.ZP)(List/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > li {\n    padding: 0 8px !important;\n  }\n  > li > a {\n    padding: 0 !important;\n  }\n  > li > a:hover {\n    text-decoration: underline;\n  }\n"])));
var ListContainer = (0,styled_components_browser_esm/* default */.ZP)(List/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  margin: 0 auto;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/SeoRelatedLinkList.js





var SeoRelatedLinkList = function SeoRelatedLinkList(_ref) {
  var _data$seoRelatedLink, _data$seoRelatedLink2;
  var data = _ref.data,
    titleText = _ref["static"].titleText;
  var onLinkClick = function onLinkClick(e, href) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  return ((_data$seoRelatedLink = data.seoRelatedLink) == null ? void 0 : _data$seoRelatedLink.length) > 0 ? react.createElement(ListContainer, null, titleText && react.createElement(SeoRelatedLinkList_styles_List.Header, {
    "data-testid": "link-list-header",
    p: " 0 8px !important"
  }, titleText), react.createElement(SeoRelatedLinkList_styles_List, {
    "data-testid": "link-list"
  }, (_data$seoRelatedLink2 = data.seoRelatedLink) == null ? void 0 : _data$seoRelatedLink2.map(function (_ref2) {
    var label = _ref2.label,
      href = _ref2.href;
    return react.createElement(SeoRelatedLinkList_styles_List.Item, {
      as: "a",
      scale: "small",
      key: 1,
      href: href,
      onClick: function onClick(e) {
        return onLinkClick(e, href);
      }
    }, label);
  }))) : null;
};
 false ? 0 : void 0;
SeoRelatedLinkList.defaultProps = {
  data: {},
  "static": {}
};
SeoRelatedLinkList.ssr = true;
/* harmony default export */ var SeoRelatedLinkList_SeoRelatedLinkList = ((0,withLayoutProps/* default */.Z)(SeoRelatedLinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/index.js


/***/ }),

/***/ 98339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesActionButtons_ServicesActionButtons; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/index.js + 2 modules
var ServicesAuthorizationTerm = __webpack_require__(73604);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/ServicesActionButtons.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;





var ActionButtonsWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: sticky;\n  bottom: 0px;\n  background-color: white;\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('medium'));
var ServicesActionButtons_styles_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 12px;\n  font-size: 16px;\n  height: 48px;\n  width: 100%;\n  margin: 0 5px;\n"])));
var ButtonsWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return {
    props: props
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 50%;\n  ", " {\n    justify-content: end;\n    flex: 3;\n    order: 3;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('medium'));
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return {
    props: props
  };
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 22px;\n  padding: 25px 20px;\n  width: 100%;\n  flex-wrap: wrap;\n  ", " {\n    flex-direction: row;\n    justify-content: end;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/ServicesActionButtons.js




var ServicesActionButtons = function ServicesActionButtons(_ref) {
  var authorizationTermText = _ref.authorizationTermText,
    handleAcquireServices = _ref.handleAcquireServices,
    hasCancelButton = _ref.hasCancelButton,
    titleCancelButton = _ref.titleCancelButton;
  return react.createElement(ActionButtonsWrapper, null, react.createElement(Wrapper, {
    "data-testid": "buttons-wrapper"
  }, react.createElement(ServicesAuthorizationTerm/* default */.Z, {
    authorizationTermText: authorizationTermText
  }), hasCancelButton && react.createElement(ButtonsWrapper, null, react.createElement(ServicesActionButtons_styles_Button, {
    color: "secondary",
    variation: "outline",
    uppercase: false,
    onClick: handleAcquireServices.continueWithoutServices,
    "data-testid": "no-services"
  }, titleCancelButton)), react.createElement(ButtonsWrapper, null, react.createElement(ServicesActionButtons_styles_Button, {
    disabled: handleAcquireServices.disableContinueAddingServices,
    "aria-disabled": handleAcquireServices.disableContinueAddingServices,
    color: "secondary",
    uppercase: false,
    onClick: handleAcquireServices.continueAddingServices,
    "data-testid": "acquire-services"
  }, "Incluir Prote\xE7\xE3o"))));
};
ServicesActionButtons.defaultProps = {
  authorizationTermText: 'Termos de autorização',
  hasCancelButton: false,
  titleCancelButton: 'Agora não'
};
 false ? 0 : void 0;
ServicesActionButtons.ssr = true;
/* harmony default export */ var ServicesActionButtons_ServicesActionButtons = ((0,react.memo)(ServicesActionButtons));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/index.js


/***/ }),

/***/ 73604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesAuthorizationTerm_ServicesAuthorizationTerm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/ServicesAuthorizationTerm.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;





var ClickableText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  text-decoration: underline;\n"])));
var DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-height: 80vh;\n  padding: ", "px ", "px;\n  ", " {\n    width: 85%;\n    padding: ", "px;\n  }\n"])), (0,esm/* themeGet */.R)('space.3'), (0,esm/* themeGet */.R)('space.2'), (0,esm/* getMediaQuery */.aK)('medium'), (0,esm/* themeGet */.R)('space.3'));
var DialogContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n"])), function (props) {
  return (0,esm/* themeGet */.R)('lineHeights.display')(props);
});
var MainText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  text-align: center;\n  margin-top: 24px;\n  ", " {\n    max-width: 358px;\n    text-align: right;\n    margin-top: 0px;\n  }\n"])), (0,esm/* themeGet */.R)('fontSizes.2'), (0,esm/* getMediaQuery */.aK)('medium'));
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  order: 3;\n  justify-content: center;\n  ", " {\n    flex: 6;\n    order: 1;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/ServicesAuthorizationTerm.js




var ServicesAuthorizationTerm = function ServicesAuthorizationTerm(_ref) {
  var authorizationTermText = _ref.authorizationTermText;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showingTac = _useState2[0],
    setShowingTac = _useState2[1];
  return react.createElement(react.Fragment, null, react.createElement(Wrapper, null, react.createElement(MainText, {
    textAlign: "center"
  }, "Ao clicar em", react.createElement("strong", null, ' "Incluir proteção" '), "voc\xEA concorda com os \xA0", react.createElement(ClickableText, {
    as: "span",
    "data-testid": "auth-term-label",
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return setShowingTac(true);
    }
  }, react.createElement("strong", null, "Termos de autoriza\xE7\xE3o de cobran\xE7a")))), react.createElement(DialogContainer, {
    "data-testid": "auth-term-dialog",
    onClickOutside: function onClickOutside() {
      return setShowingTac(false);
    },
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: showingTac,
    showClose: true
  }, react.createElement(DialogContent, {
    dangerouslySetInnerHTML: {
      __html: authorizationTermText
    }
  })));
};
ServicesAuthorizationTerm.defaultProps = {
  authorizationTermText: 'Termos de autorização'
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesAuthorizationTerm_ServicesAuthorizationTerm = (ServicesAuthorizationTerm);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/index.js


/***/ }),

/***/ 69913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesCard_ServicesCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/index.js + 2 modules
var ServicesOfferPriceAndInstallments = __webpack_require__(60015);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServicesCard.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;






var ServicesCard_styles_Checkbox = (0,styled_components_browser_esm/* default */.ZP)(Checkbox/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  input {\n    min-width: 20px;\n  }\n"])));
var ServicesCard_styles_HorizontalRule = (0,styled_components_browser_esm/* default */.ZP)(HorizontalRule/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 12px 4px 0px;\n  width: 100%;\n\n  ", " {\n    margin: 16px 4px 0px;\n    width: auto;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('medium'));
var RecommendedContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-end',
    flexDirection: 'column'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 12px;\n  padding-right: 16px;\n  visibility: ", ";\n"])), function (props) {
  return (props == null ? void 0 : props.recommended) ? 'visible' : 'hidden';
});
var RecommendedText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    backgroundColor: 'primary.base',
    color: 'white'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 7px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 2px 6px;\n"])));
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    borderRadius: 8,
    color: 'greyishBrown',
    flexDirection: 'column'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServiceCheckbox.js







var ServiceCheckbox = function ServiceCheckbox(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    offerId = _ref.offerId,
    title = _ref.title,
    selectedOfferPrice = _ref.selectedOfferPrice;
  var handleChange = function handleChange(event) {
    onChange(event.target.checked ? offerId : null);
  };
  return react.createElement(Box/* default */.Z, {
    pl: 3,
    pr: 3
  }, react.createElement(ServicesCard_styles_Checkbox, {
    checked: checked,
    onChange: handleChange
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    fontSize: 2
  }, title)), react.createElement(Flex/* default */.Z, {
    justifyContent: "space-between",
    alignItems: "left",
    marginTop: "20px"
  }, react.createElement(ServicesOfferPriceAndInstallments/* default */.Z, selectedOfferPrice)));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesCard_ServiceCheckbox = (ServiceCheckbox);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServicesCard.js




var ServicesCard = function ServicesCard(props) {
  var title = props.title,
    checked = props.checked,
    onChange = props.onChange,
    value = props.value,
    recommended = props.recommended,
    selectedOfferPrice = props.selectedOfferPrice;
  return react.createElement(Wrapper, {
    "data-testid": "service-card"
  }, react.createElement(RecommendedContainer, {
    recommended: recommended,
    "data-testid": "recommended-container"
  }, react.createElement(RecommendedText, null, "Recomendado")), react.createElement(ServicesCard_ServiceCheckbox, {
    checked: checked,
    onChange: onChange,
    title: title,
    offerId: value,
    selectedOfferPrice: selectedOfferPrice
  }), react.createElement(ServicesCard_styles_HorizontalRule, {
    size: 2
  }));
};
ServicesCard.defaultProps = {
  selectedOfferPrice: {}
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesCard_ServicesCard = (ServicesCard);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/index.js


/***/ }),

/***/ 28946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesGroup_ServicesGroup; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(88699);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/index.js + 3 modules
var ServicesCard = __webpack_require__(69913);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/index.js + 5 modules
var ServicesInfo = __webpack_require__(80496);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/ServicesGroup.styles.js


var _templateObject, _templateObject2, _templateObject3;




var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var ExtraInfoFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    flexDirection: 'column',
    mb: 2,
    pb: 3
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: fit-content;\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,build_esm/* getMediaQuery */.aK)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/utils.js
var findCheckedIndex = function findCheckedIndex(options) {
  var selected = options.findIndex(function (option) {
    return option.checked;
  });
  return selected !== -1 ? selected : options.findIndex(function (option) {
    return option.recommended;
  });
};
var findMaxIndexCheckedOrRecomended = function findMaxIndexCheckedOrRecomended(options) {
  var checkedIndex = options.findIndex(function (option) {
    return option.checked;
  });
  var recommendedIndex = options.findIndex(function (option) {
    return option.recommended;
  });
  return Math.max(checkedIndex, recommendedIndex);
};
var optionsHideCardsCollapsed = function optionsHideCardsCollapsed(isOpen, selectedIndex, options) {
  if (!isOpen) {
    return selectedIndex !== -1 ? [options[selectedIndex]] : [options[0]];
  }
  return options;
};
var optionsShowCardsCollapsed = function optionsShowCardsCollapsed(isOpen, selectedIndex, options, serviceKey, visibleCards) {
  if (visibleCards[serviceKey]) {
    var valuesToShow = selectedIndex > 0 ? selectedIndex + 1 : visibleCards[serviceKey];
    return options == null ? void 0 : options.filter(function (option, index) {
      return index < valuesToShow || isOpen || option.checked;
    });
  }
  return options;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/ServicesGroup.js












var ServiceIds = {
  GARANTIA_ESTENDIDA: 5,
  ROUBO_E_FURTO: 3,
  TROCA_CERTA: 4
};
var ServicesGroup = function ServicesGroup(props) {
  var _service$period2;
  var service = props.service;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var extraInfo = service.extraInfo;
  var onInfoClick = extraInfo.onInfoClick,
    _extraInfo$serviceGro = extraInfo.serviceGroupLayoutConfig,
    serviceGroupLayoutConfig = _extraInfo$serviceGro === void 0 ? {
      showCardsCollapsed: true,
      visibleCards: (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, ServiceIds.ROUBO_E_FURTO, 2), ServiceIds.TROCA_CERTA, 2), ServiceIds.GARANTIA_ESTENDIDA, 1)
    } : _extraInfo$serviceGro;
  var showCardsCollapsed = serviceGroupLayoutConfig.showCardsCollapsed,
    visibleCards = serviceGroupLayoutConfig.visibleCards;
  var handleInfoClick = function handleInfoClick() {
    setIsOpen(!isOpen);
    onInfoClick(!isOpen);
  };
  var memorizedSelectedIndex = (0,react.useMemo)(function () {
    var _service$period;
    var options = service == null ? void 0 : (_service$period = service.period) == null ? void 0 : _service$period.options;
    return showCardsCollapsed ? findMaxIndexCheckedOrRecomended(options) : findCheckedIndex(options);
  }, [isOpen]);
  var renderShowCardsCollapsed = function renderShowCardsCollapsed(options, serviceKey) {
    var _optionsShowCardsColl;
    return (_optionsShowCardsColl = optionsShowCardsCollapsed(isOpen, memorizedSelectedIndex, options, serviceKey, visibleCards)) == null ? void 0 : _optionsShowCardsColl.map(function (option) {
      return react.createElement(ServicesCard/* default */.Z, (0,esm_extends/* default */.Z)({
        key: "period-".concat(option == null ? void 0 : option.value)
      }, option));
    });
  };
  var renderHideCardsCollapsed = function renderHideCardsCollapsed(options) {
    var _optionsHideCardsColl;
    return (_optionsHideCardsColl = optionsHideCardsCollapsed(isOpen, memorizedSelectedIndex, options)) == null ? void 0 : _optionsHideCardsColl.map(function (option) {
      return react.createElement(ServicesCard/* default */.Z, (0,esm_extends/* default */.Z)({
        key: "period-".concat(option == null ? void 0 : option.value)
      }, option));
    });
  };
  var renderGroupServicesCard = function renderGroupServicesCard(options, serviceKey) {
    if (showCardsCollapsed) {
      return renderShowCardsCollapsed(options, serviceKey);
    }
    return renderHideCardsCollapsed(options);
  };
  return react.createElement(Wrapper, {
    key: service == null ? void 0 : service.key,
    "data-testid": "service-group"
  }, renderGroupServicesCard(service == null ? void 0 : (_service$period2 = service.period) == null ? void 0 : _service$period2.options, service.key), extraInfo && Object.keys(extraInfo).length > 0 && react.createElement(Box/* default */.Z, null, react.createElement(Collapse/* default */.Z, {
    trigger: !isOpen
  }, react.createElement(ServicesInfo/* default */.Z, extraInfo)), react.createElement(ExtraInfoFlex, {
    alignItems: "center",
    onClick: handleInfoClick,
    pt: 3,
    pl: 3,
    pr: 3
  }, react.createElement(Text/* default */.Z, {
    as: "span",
    fontSize: 1,
    "data-testid": "open-service-info"
  }, "Ver mais"), react.createElement(ArrowIcon, {
    name: "Chevron".concat(isOpen ? 'Up' : 'Down')
  }))));
};
ServicesGroup.defaultProps = {
  service: {}
};
var benefitPropType =  false ? 0 : {};
var extraInfoPropType =  false ? 0 : {};
var serviceGroupLayoutConfigPropTypes =  false ? 0 : {};
var selectedOfferPricePropType =  false ? 0 : {};
var periodOptionPropType =  false ? 0 : {};
var periodPropType =  false ? 0 : {};
var servicePropType =  false ? 0 : {};
 false ? 0 : void 0;
/* harmony default export */ var ServicesGroup_ServicesGroup = ((0,react.memo)(ServicesGroup));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/index.js


/***/ }),

/***/ 80496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesInfo_ServicesInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/ServicesInfo.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;







var AgreementContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('lineHeights.display')(props);
});
var AgreementLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 13,
    lineHeight: '16px',
    paddingLeft: '16px',
    width: '144px'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var BenefitContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: 10,
    textAlign: 'left'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BenefitPriceText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '20px',
    p: 2,
    width: '100%'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 16px;\n  background-color: #f1ffe7;\n  font-weight: 500;\n"])));
var BenefitText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '20px',
    pl: 2,
    pr: 2
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14px;\n"])));
var DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-height: 80vh;\n  padding: ", "px ", "px;\n  ", " {\n    width: 85%;\n    padding: ", "px;\n  }\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.2'), (0,stereo_ui_styles_build_esm/* getMediaQuery */.aK)('medium'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'));
var IconCheck = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#429502',
    height: 25,
    marginRight: 9,
    minHeight: 25,
    minWidth: 25,
    width: 25
  }, props);
})(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var IconPrize = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#429502',
    height: 40,
    marginRight: 9,
    minHeight: 40,
    minWidth: 40,
    paddingLeft: 9,
    width: 40
  }, props);
})(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var RuleWithMargin = (0,styled_components_browser_esm/* default */.ZP)(HorizontalRule/* default */.Z)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: '16px 0';\n  width: '100%';\n"])));
var VideoContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-height: 260px;\n\n  &::after {\n    padding-top: 56.25%;\n    display: block;\n    content: '';\n  }\n\n  > iframe {\n    width: 100%;\n    height: 255px;\n  }\n"])));
var VideoWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0px 30px 8px 30px;\n  border-top: 1px solid #ccc;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/Benefits.js




var Benefits = function Benefits(_ref) {
  var benefit = _ref.benefit;
  var benefitLength = benefit == null ? void 0 : benefit.length;
  return react.createElement(react.Fragment, null, benefit == null ? void 0 : benefit.map(function (_ref2, index) {
    var description = _ref2.description,
      iconName = _ref2.iconName;
    var isLastItem = index + 1 < benefitLength;
    return isLastItem ? react.createElement(BenefitText, {
      key: (0,esm/* slug */.oF)(description + index),
      "data-testid": "benefit-container",
      pr: 2
    }, react.createElement(IconCheck, {
      name: iconName !== null && iconName !== void 0 ? iconName : 'Done',
      "data-testid": "benefit-icon"
    }), description) : react.createElement(BenefitPriceText, {
      key: (0,esm/* slug */.oF)(description + index),
      "data-testid": "benefit-container",
      pr: 3
    }, react.createElement(IconPrize, {
      name: iconName !== null && iconName !== void 0 ? iconName : 'Done',
      "data-testid": "benefit-icon"
    }), description);
  }));
};
Benefits.defaultProps = {
  benefit: [{
    description: '',
    iconName: ''
  }]
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesInfo_Benefits = (Benefits);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/Dialog.js




var Dialog_Dialog = function Dialog(props) {
  var agreementModalOpen = props.agreementModalOpen,
    agreementText = props.agreementText,
    handleClickEvent = props.handleClickEvent,
    open = props.open,
    videoModalOpen = props.videoModalOpen,
    videoUrl = props.videoUrl;
  return react.createElement(DialogContainer, {
    "data-testid": "dialog-container",
    onClickOutside: function onClickOutside() {
      return handleClickEvent(videoModalOpen ? 'video' : 'agreement');
    },
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: open,
    showClose: true,
    pl: 3,
    pr: 3
  }, agreementModalOpen && react.createElement(AgreementContent, {
    dangerouslySetInnerHTML: {
      __html: agreementText
    },
    "data-testid": "agreement-content"
  }), videoModalOpen && react.createElement(VideoContent, {
    pl: 3,
    pr: 3
  }, react.createElement("iframe", {
    src: (0,esm/* parseVideoUrl */.$4)(videoUrl),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    "data-testid": "video-content"
  })));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesInfo_Dialog = (Dialog_Dialog);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/useServicesInfo.js


var useServicesInfo = function useServicesInfo(props) {
  var benefit = props.benefit,
    title = props.title,
    agreementText = props.agreementText,
    label = props.label,
    labelBold = props.labelBold,
    videoUrl = props.videoUrl,
    onModalOpen = props.onModalOpen;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    agreementModalOpen = _useState4[0],
    setAgreementModalOpen = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    videoModalOpen = _useState6[0],
    setVideoModalOpen = _useState6[1];
  var handleClickEvent = (0,react.useCallback)(function (modalType) {
    setOpen(!open);
    if (onModalOpen) onModalOpen({
      modalType: modalType,
      open: !open
    });
    if (modalType === 'agreement') {
      setAgreementModalOpen(!agreementModalOpen);
      setVideoModalOpen(false);
      return;
    }
    setVideoModalOpen(!videoModalOpen);
    setAgreementModalOpen(false);
  }, [agreementModalOpen, videoModalOpen]);
  return {
    agreement: {
      title: title
    },
    benefit: benefit,
    dialog: {
      agreementModalOpen: agreementModalOpen,
      agreementText: agreementText,
      open: open,
      videoModalOpen: videoModalOpen,
      videoUrl: videoUrl
    },
    handleClickEvent: handleClickEvent,
    video: {
      label: label,
      labelBold: labelBold
    }
  };
};
/* harmony default export */ var ServicesInfo_useServicesInfo = (useServicesInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/ServicesInfo.js










var ServicesInfo = function ServicesInfo(props) {
  var showVideo = props.showVideo,
    videoUrl = props.videoUrl;
  var _useServicesInfo = ServicesInfo_useServicesInfo(props),
    agreement = _useServicesInfo.agreement,
    benefit = _useServicesInfo.benefit,
    dialog = _useServicesInfo.dialog,
    handleClickEvent = _useServicesInfo.handleClickEvent,
    video = _useServicesInfo.video;
  return react.createElement(react.Fragment, null, react.createElement(BenefitContainer, {
    mb: 2,
    mt: 3
  }, react.createElement(ServicesInfo_Benefits, {
    benefit: benefit
  })), video.label && react.createElement(react.Fragment, null, react.createElement(RuleWithMargin, null), showVideo && react.createElement(VideoContent, null, react.createElement("iframe", {
    src: (0,esm/* parseVideoUrl */.$4)(videoUrl),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    "data-testid": "video-content"
  }))), agreement.title && react.createElement(react.Fragment, null, react.createElement(RuleWithMargin, null), react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    pr: 3
  }, react.createElement(AgreementLabel, {
    onClick: function onClick() {
      return handleClickEvent('agreement');
    },
    "data-testid": "agreement-trigger",
    mb: 3,
    mt: 3
  }, agreement.title), react.createElement(ArrowIcon, {
    name: "ChevronRight"
  }))), react.createElement(HorizontalRule/* default */.Z, null), react.createElement(ServicesInfo_Dialog, (0,esm_extends/* default */.Z)({
    handleClickEvent: handleClickEvent
  }, dialog)));
};
ServicesInfo.defaultProps = {
  agreementText: '',
  benefit: [{
    description: ''
  }],
  label: '',
  labelBold: '',
  showVideo: false,
  title: '',
  videoUrl: ''
};
 false ? 0 : void 0;
ServicesInfo.ssr = true;
/* harmony default export */ var ServicesInfo_ServicesInfo = (ServicesInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/index.js


/***/ }),

/***/ 60015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesOfferPriceAndInstallments_ServicesOfferPriceAndInstallments; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/ServicesOfferPriceAndInstallments.styles.js

var _templateObject;


var StrikeText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: line-through;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/ServicesOfferPriceAndInstallments.js





var ServicesOfferPriceAndInstallments = function ServicesOfferPriceAndInstallments(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    pretitle = _ref.pretitle;
  return react.createElement(Box/* default */.Z, {
    "data-testid": "price-installments-container"
  }, react.createElement(Text/* default */.Z, {
    color: "gray",
    textAlign: "left",
    fontSize: 1,
    "data-testid": "pretitle-text"
  }, pretitle && react.createElement(react.Fragment, null, 'de ', react.createElement(StrikeText, {
    color: "gray",
    as: "span"
  }, pretitle))), react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    textAlign: "left",
    fontSize: 2,
    "data-testid": "title-text",
    padding: "6px 0px"
  }, title.text, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    as: "span"
  }, title.bold)), react.createElement(Text/* default */.Z, {
    color: "gray",
    textAlign: "left",
    fontWeight: "500",
    fontSize: 1,
    "data-testid": "subtitle-text"
  }, subtitle));
};
 false ? 0 : void 0;
ServicesOfferPriceAndInstallments.defaultProps = {
  pretitle: undefined
};
ServicesOfferPriceAndInstallments.ssr = true;
/* harmony default export */ var ServicesOfferPriceAndInstallments_ServicesOfferPriceAndInstallments = (ServicesOfferPriceAndInstallments);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/index.js


/***/ }),

/***/ 77900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesProductCard_ServicesProductCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/ServicesProductCard.styles.js


var _templateObject, _templateObject2;




var Image = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  height: 79px;\n  width: 79px;\n"])));
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    bg: 'background.white',
    color: 'greyisBrown',
    mb: 2,
    mt: 2,
    p: 2
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,esm/* getMediaQuery */.aK)('small'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/ServicesProductCard.js




var ServicesProductCard = function ServicesProductCard(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    title = _ref.title;
  return react.createElement(Wrapper, {
    "data-testid": "product-service"
  }, react.createElement(Image, {
    src: src,
    alt: alt
  }), react.createElement(Text/* default */.Z, null, title));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesProductCard_ServicesProductCard = (ServicesProductCard);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/index.js


/***/ }),

/***/ 79648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesWrapper_ServicesWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/index.js + 3 modules
var ServicesGroup = __webpack_require__(28946);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.styles.js

var _templateObject;



var ServicesGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: minmax(0, 1fr);\n  ", " {\n    grid-template-columns: ", ";\n  }\n"])), (0,esm/* getMediaQuery */.aK)('small'), function (props) {
  return "repeat(".concat(props.nCards || 1, ", 1fr)");
});
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.types.js

var ServicesWrapperPropTypes = {
  services: (0,prop_types.arrayOf)((0,prop_types.shape)({
    benefit: (0,prop_types.arrayOf)((0,prop_types.shape)({
      description: prop_types.string
    })),
    extraInfo: (0,prop_types.shape)({
      agreementText: prop_types.string,
      benefit: (0,prop_types.arrayOf)((0,prop_types.shape)({
        description: prop_types.string
      })),
      label: prop_types.string,
      labelBold: prop_types.string,
      title: prop_types.string,
      videoUrl: prop_types.string
    }),
    label: prop_types.string,
    labelBold: prop_types.string,
    period: (0,prop_types.shape)({
      options: (0,prop_types.arrayOf)((0,prop_types.shape)({
        checked: prop_types.bool,
        recommended: prop_types.bool,
        selectedOfferPrice: (0,prop_types.shape)({
          subtitle: prop_types.string,
          title: (0,prop_types.shape)({
            bold: prop_types.string,
            text: prop_types.string
          })
        }),
        title: prop_types.string,
        value: prop_types.number
      })),
      value: prop_types.number
    }),
    title: prop_types.string,
    videoUrl: prop_types.string
  })).isRequired
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.js





var ServicesWrapper = function ServicesWrapper(props) {
  var services = props.services;
  return react.createElement(ServicesGrid, {
    "data-testid": "services-grid",
    nCards: services.length
  }, services.map(function (service) {
    return react.createElement(ServicesGroup/* default */.Z, {
      key: "services-group-".concat(service.key),
      service: service
    });
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesWrapper_ServicesWrapper = ((0,withLayoutProps/* default */.Z)(ServicesWrapper));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/index.js


/***/ }),

/***/ 644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareActions_ShareActions; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js + 2 modules
var CopyToClipboard = __webpack_require__(12241);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js + 2 modules
var Radio = __webpack_require__(70715);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useShortenLink.js
var useShortenLink = __webpack_require__(15138);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/ProductLink.styles.js

var _templateObject;

var Grid = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: auto auto;\n\n  & label {\n    padding-top: 0;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/hooks/setShortLink.js

var setShortLink = function setShortLink(shortenedLink, shortenType, setUrlToCopy) {
  (0,react.useEffect)(function () {
    if (shortenedLink) {
      sessionStorage.setItem(shortenType, shortenedLink);
      setUrlToCopy(shortenedLink);
    }
  }, [shortenedLink]);
};
/* harmony default export */ var hooks_setShortLink = (setShortLink);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/ProductLink.js












var ProductLink = function ProductLink(_ref) {
  var _shortenedConfigs$mag, _shortenedConfigs$one, _window2, _window2$location;
  var sectionUrl = _ref.sectionUrl,
    structure = _ref.structure;
  var shareUrlCookie = (0,esm/* getCookie */.ej)('toggle_shareurl_pmd_v2') || '';
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isShortUrl = _useState2[0],
    setIsShortUrl = _useState2[1];
  var _useState3 = (0,react.useState)('store'),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    typeUrl = _useState4[0],
    setTypeUrl = _useState4[1];
  var _useState5 = (0,react.useState)(sectionUrl.url),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    urlToCopy = _useState6[0],
    setUrlToCopy = _useState6[1];
  var isWindowNotUndefined = typeof window !== 'undefined';
  var shouldShowShortenRadios = (sectionUrl == null ? void 0 : sectionUrl.allowSuperAppLink) && shareUrlCookie.includes('app');
  var shouldShowShortenCheckbox = shareUrlCookie.includes('shorten') && typeUrl === 'store';
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config;
  var toShortenUrls = {
    desktop: "".concat(config.domain).concat(asPath),
    magaly: "".concat(config.domain).concat(asPath),
    onelink: "https://m.magazineluiza.com.br".concat(asPath == null ? void 0 : asPath.split(basePath).join(''))
  };
  var resetShortenSearch = function resetShortenSearch() {
    var _window$sessionStorag, _window$sessionStorag2;
    setUrlToCopy(sectionUrl.url);
    setTypeUrl('store');
    setIsShortUrl(false);
    (_window$sessionStorag = window.sessionStorage) == null ? void 0 : _window$sessionStorag.setItem('shorten_magaly', null);
    (_window$sessionStorag2 = window.sessionStorage) == null ? void 0 : _window$sessionStorag2.setItem('shorten_onelink', null);
  };
  var shortenedConfigs = {
    magaly: (0,useShortenLink/* default */.Z)('shortenlink-magaly', {
      link: toShortenUrls.magaly
    }),
    onelink: (0,useShortenLink/* default */.Z)('shortenlink-onelink', {
      addPartnerId: true,
      desktopLink: toShortenUrls.desktop,
      link: toShortenUrls.onelink
    })
  };
  hooks_setShortLink(shortenedConfigs == null ? void 0 : (_shortenedConfigs$mag = shortenedConfigs.magaly) == null ? void 0 : _shortenedConfigs$mag.shortLink, 'shorten_magaly', setUrlToCopy);
  hooks_setShortLink(shortenedConfigs == null ? void 0 : (_shortenedConfigs$one = shortenedConfigs.onelink) == null ? void 0 : _shortenedConfigs$one.shortLink, 'shorten_onelink', setUrlToCopy);
  (0,react.useEffect)(function () {
    sessionStorage.setItem('shorten_magaly', null);
    sessionStorage.setItem('shorten_onelink', null);
  }, []);
  (0,react.useEffect)(function () {
    var _window, _window$location;
    return isWindowNotUndefined && ((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.href) && resetShortenSearch();
  }, [isWindowNotUndefined && ((_window2 = window) == null ? void 0 : (_window2$location = _window2.location) == null ? void 0 : _window2$location.href)]);
  (0,react.useEffect)(function () {
    var type;
    if (isShortUrl && typeUrl === 'store') type = 'magaly';
    if (typeUrl === 'app') type = 'onelink';
    if (type) {
      var url = sessionStorage.getItem("shorten_".concat(type));
      if (!url || url === 'null' || url === 'undefined') shortenedConfigs[type].handleShortenLink();else setUrlToCopy(url);
    } else {
      setUrlToCopy(sectionUrl.url);
    }
  }, [isShortUrl, typeUrl]);
  return react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionUrl.title), shouldShowShortenRadios && react.createElement(Grid, null, react.createElement(Radio/* default */.Z, {
    label: "Minha loja",
    value: "store",
    checked: typeUrl === 'store',
    onChange: function onChange(e) {
      return setTypeUrl(e.target.value);
    }
  }), react.createElement(Radio/* default */.Z, {
    label: "App do Magalu",
    value: "app",
    checked: typeUrl === 'app',
    onChange: function onChange(e) {
      return setTypeUrl(e.target.value);
    }
  })), react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(CopyToClipboard/* default */.Z, {
    value: urlToCopy
  })), shouldShowShortenCheckbox && react.createElement(Checkbox/* default */.Z, {
    checked: isShortUrl,
    onChange: function onChange(e) {
      setIsShortUrl(e.target.checked);
    },
    fontSize: 1,
    mb: 3
  }, "Link curto"));
};
 false ? 0 : void 0;
ProductLink.defaultProps = {
  sectionUrl: {
    allowSuperAppLink: false,
    title: 'Link do produto',
    url: '#'
  },
  structure: {}
};
ProductLink.ssr = false;
ProductLink.displayName = 'ProductLink';
/* harmony default export */ var ProductLink_ProductLink = (ProductLink);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/SharedBag.styles.js

var SharedBag_styles_templateObject;



var SharedBagButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(SharedBag_styles_templateObject || (SharedBag_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  font-size: ", "px;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.white')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/SharedBag.js


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }








var SharedBag = function SharedBag(_ref) {
  var sectionSharedBag = _ref.sectionSharedBag,
    product = _ref.product,
    storeNumericId = _ref.storeNumericId,
    cookieDomain = _ref.cookieDomain;
  var _useSharedBag = (0,graphql_build_esm.useSharedBag)(),
    addToSharedBag = _useSharedBag.addToSharedBag;
  var PMD_SHAREDBAG = esm/* cookiesConstants.PMD_SHAREDBAG */.VD.PMD_SHAREDBAG;
  var showSectionSharedBag = (sectionSharedBag == null ? void 0 : sectionSharedBag.show) === 'true';
  var seller = product.seller.id;
  var sku = product.variationId;
  var sharedBagId = (0,esm/* getCookie */.ej)(PMD_SHAREDBAG);
  var createSharedBag = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _yield$addToSharedBag, sharedBagData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return addToSharedBag({
              seller: seller,
              sharedBagId: sharedBagId,
              sku: sku,
              storeNumericId: storeNumericId
            });
          case 2:
            _yield$addToSharedBag = _context.sent;
            sharedBagData = _yield$addToSharedBag.data;
            if (sharedBagData && typeof (sharedBagData == null ? void 0 : sharedBagData.id) === 'string') {
              (0,esm/* setCookie */.d8)({
                domain: cookieDomain,
                name: PMD_SHAREDBAG,
                value: sharedBagData.id
              });
              (0,esm/* routePush */.dY)({
                path: "".concat(sectionSharedBag.url, "/").concat(sharedBagData.id),
                spa: false
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createSharedBag() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!showSectionSharedBag) {
    return null;
  }
  return react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSharedBag.title), react.createElement(SharedBagButton, {
    color: "primary",
    "data-testid": "sharedbag-button",
    full: true,
    href: "#",
    mr: 3,
    onClick: function onClick() {
      createSharedBag();
    },
    rel: "noopener",
    size: "large",
    startIcon: react.createElement(build_esm/* Icon */.JO$, {
      name: "ShoppingBag",
      width: 32,
      height: 32
    }),
    target: "_blank",
    title: "ShoppingBag",
    variation: "outline"
  }, sectionSharedBag.buttonLabel));
};
 false ? 0 : void 0;
SharedBag.defaultProps = {
  cookieDomain: '',
  product: {
    seller: {
      id: ''
    },
    variationId: ''
  },
  sectionSharedBag: {
    buttonLabel: 'Adicionar na sacola pronta',
    show: 'false',
    title: 'Compartilhe produtos na sacola pronta',
    url: '#'
  },
  storeNumericId: ''
};
SharedBag.ssr = false;
SharedBag.displayName = 'SharedBag';
/* harmony default export */ var SharedBag_SharedBag = (SharedBag);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/index.js

// EXTERNAL MODULE: ../../node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(38001);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/commons/isValidStaticProp.js
var isValidStaticProp = __webpack_require__(68909);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/SocialMedia.styles.js

var SocialMedia_styles_templateObject;


var SharedActionsIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$)(SocialMedia_styles_templateObject || (SocialMedia_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/SocialMedia.js












var SocialMedia = function SocialMedia(_ref) {
  var sectionSocial = _ref.sectionSocial,
    sectionUrl = _ref.sectionUrl;
  var qrCodeRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openQRCodeModal = _useState2[0],
    setOpenQRCodeModal = _useState2[1];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleQRCodeDownload = function handleQRCodeDownload() {
    var svgData = new XMLSerializer().serializeToString(qrCodeRef.current);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var img = new Image();
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      var pngFile = canvas.toDataURL('image/png');
      var downloadLink = document.createElement('a');
      downloadLink.download = 'QRCode';
      downloadLink.href = "".concat(pngFile);
      downloadLink.click();
      setOpenQRCodeModal(false);
    };
    img.src = "data:image/svg+xml;base64,".concat(btoa(svgData));
  };
  var handleClick = function handleClick(event, _ref2) {
    var eventType = _ref2.eventType,
      href = _ref2.href;
    if (href === '#') {
      event.preventDefault();
      setOpenQRCodeModal(true);
    }
    publish(eventType);
  };
  return react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSocial.title), react.createElement(Flex/* default */.Z, null, Object.entries(sectionSocial.buttons).map(function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      entry = _ref4[0],
      _ref4$ = _ref4[1],
      href = _ref4$.href,
      _ref4$$name = _ref4$.name,
      name = _ref4$$name === void 0 ? '' : _ref4$$name,
      color = _ref4$.color,
      eventType = _ref4$.eventType,
      _ref4$$iconColor = _ref4$.iconColor,
      iconColor = _ref4$$iconColor === void 0 ? '#fff' : _ref4$$iconColor,
      customColor = _ref4$.customColor;
    return (0,isValidStaticProp/* default */.Z)(href) && react.createElement(Button/* default */.Z, {
      key: "".concat(entry, "-").concat(name),
      as: "a",
      title: name,
      centered: false,
      color: color,
      customColor: customColor,
      "data-testid": "share-actions-".concat(name.toLowerCase(), "-button"),
      disabled: false,
      full: false,
      href: href,
      target: "_blank",
      rel: "noopener",
      onClick: function onClick(event) {
        return handleClick(event, {
          eventType: eventType,
          href: href
        });
      },
      variation: "fill",
      size: "auto",
      height: "52px",
      width: "52px",
      mr: 3
    }, react.createElement(SharedActionsIcon, {
      name: name,
      color: iconColor,
      width: 32,
      height: 32
    }));
  })), react.createElement(Dialog/* default */.Z, {
    visible: openQRCodeModal,
    onClickOutside: function onClickOutside() {
      return setOpenQRCodeModal(false);
    },
    type: "alert",
    bg: "background.white",
    position: "center",
    showClose: true
  }, react.createElement(Text/* default */.Z, {
    mt: "2",
    textAlign: "center"
  }, react.createElement(lib/* default */.ZP, {
    "data-testid": "share-actions-modal-qrcode",
    ref: qrCodeRef,
    value: sectionUrl.url
  })), react.createElement(Button/* default */.Z, {
    "data-testid": "share-actions-btn-download-qrcode",
    onClick: handleQRCodeDownload,
    m: "10px 0 0",
    variation: "outline",
    full: true
  }, sectionUrl.downloadQRCode)));
};
 false ? 0 : void 0;
SocialMedia.defaultProps = {
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  sectionUrl: {
    downloadQRCode: 'Baixar QR code',
    title: 'Link do produto',
    url: '#'
  }
};
SocialMedia.ssr = false;
SocialMedia.displayName = 'SocialMedia';
/* harmony default export */ var SocialMedia_SocialMedia = (SocialMedia);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/ShareActions.js








var ShareActions = function ShareActions(_ref) {
  var _channel$data$, _channel$data$$value, _structure$config;
  var data = _ref.data,
    StaticProps = _ref["static"],
    structure = _ref.structure;
  var channel = data.channel,
    product = data.product;
  var sectionSharedBag = StaticProps.sectionSharedBag,
    sectionSocial = StaticProps.sectionSocial,
    sectionUrl = StaticProps.sectionUrl;
  return react.createElement(Flex/* default */.Z, {
    flexDirection: "column"
  }, react.createElement(Text/* default */.Z, {
    fontSize: 2,
    fontWeight: "medium",
    mb: 3,
    mt: 2
  }, StaticProps.title), react.createElement(SharedBag_SharedBag, {
    sectionSharedBag: sectionSharedBag,
    product: product,
    storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
    cookieDomain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain
  }), react.createElement(ProductLink_ProductLink, {
    sectionUrl: sectionUrl,
    structure: structure
  }), react.createElement(SocialMedia_SocialMedia, {
    sectionUrl: sectionUrl,
    sectionSocial: sectionSocial
  }));
};
 false ? 0 : void 0;
ShareActions.defaultProps = {
  data: {
    channel: {}
  },
  "static": {
    sectionSharedBag: {
      buttonLabel: 'Adicionar na sacola pronta',
      show: 'false',
      title: 'Compartilhe produtos na sacola pronta',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    },
    sectionUrl: {
      downloadQRCode: 'Baixar QR code',
      title: 'Link do produto',
      url: '#'
    },
    title: 'Ferramentas do Divulgador'
  },
  structure: {}
};
ShareActions.ssr = false;
ShareActions.displayName = 'ShareActions';
/* harmony default export */ var ShareActions_ShareActions = ((0,withLayoutProps/* default */.Z)(ShareActions));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/index.js


/***/ }),

/***/ 58258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareLinks_ShareLinks; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js + 2 modules
var CopyToClipboard = __webpack_require__(12241);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useShortenLink.js
var useShortenLink = __webpack_require__(15138);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../modules/build/esm/commons/isValidStaticProp.js
var isValidStaticProp = __webpack_require__(68909);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/SocialMedia.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;





var SharedActionsIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var SocialMediaButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 44px;\n  min-width: 0;\n  border-radius: 100%;\n  background-color: ", " !important;\n"])), function (_ref2) {
  var color = _ref2.color;
  return color;
});
var SocialMediaContainerButtons = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 86px;\n"])));
var SocialMediaContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  gap: 20px;\n  overflow-x: auto;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/SocialMedia.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }







var SocialMedia = function SocialMedia(_ref) {
  var sectionSocial = _ref.sectionSocial,
    structure = _ref.structure,
    device = _ref.device,
    urlToCopy = _ref.urlToCopy;
  var _useState = (0,react.useState)('Copiar link'),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    copyButtonText = _useState2[0],
    setCopyButtonText = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    isCopyButtonDisabled = _useState4[0],
    setIsCopyButtonDisabled = _useState4[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var copyTimeoutRef = (0,react.useRef)(null);
  var isDesktop = device === 'desktop';
  var publishShareEvent = function publishShareEvent(shareActionType) {
    publish('pmd:sharelinks:share:product:click', {
      pageType: structure == null ? void 0 : structure.name,
      productId: structure == null ? void 0 : structure.route.productId,
      productName: isDesktop ? structure == null ? void 0 : structure.route.slug : structure == null ? void 0 : structure.route.productSlug,
      shareAction: shareActionType
    });
  };
  var handleShareSocial = function handleShareSocial(eventType, href) {
    window.open(href, '_blank', 'noopener,noreferrer');
    publish(eventType);
    publishShareEvent(eventType);
  };
  var handleCopy = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCopyButtonDisabled) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            publishShareEvent('copiar-link');
            _context.next = 5;
            return navigator.clipboard.writeText(urlToCopy);
          case 5:
            setCopyButtonText('Link Copiado!');
            setIsCopyButtonDisabled(true);
            if (copyTimeoutRef.current) {
              clearTimeout(copyTimeoutRef.current);
            }
            copyTimeoutRef.current = setTimeout(function () {
              setCopyButtonText('Copiar link');
              setIsCopyButtonDisabled(false);
              copyTimeoutRef.current = null;
            }, 10000);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCopy() {
      return _ref2.apply(this, arguments);
    };
  }();
  (0,react.useEffect)(function () {
    return function () {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);
  return react.createElement(Box/* default */.Z, {
    "data-testid": "share-links-social-media"
  }, react.createElement(Text/* default */.Z, {
    as: "p",
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSocial.title), react.createElement(SocialMediaContent, null, !isDesktop && react.createElement(SocialMediaContainerButtons, null, react.createElement(SocialMediaButton, {
    "data-testid": "mobile-copy-link-button",
    color: "#D3DADD",
    onClick: handleCopy,
    disabled: isCopyButtonDisabled,
    "aria-label": copyButtonText
  }, react.createElement(SharedActionsIcon, {
    name: "Link",
    color: "#1E2428",
    width: 24,
    height: 24
  })), react.createElement(Text/* default */.Z, {
    "data-testid": "mobile-copy-link-button-text",
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, copyButtonText)), Object.entries(sectionSocial.buttons).map(function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      entry = _ref4[0],
      _ref4$ = _ref4[1],
      href = _ref4$.href,
      _ref4$$name = _ref4$.name,
      name = _ref4$$name === void 0 ? '' : _ref4$$name,
      color = _ref4$.color,
      eventType = _ref4$.eventType,
      _ref4$$iconColor = _ref4$.iconColor,
      iconColor = _ref4$$iconColor === void 0 ? '#fff' : _ref4$$iconColor;
    return (0,isValidStaticProp/* default */.Z)(href) && react.createElement(SocialMediaContainerButtons, {
      key: "".concat(entry, "-").concat(name)
    }, react.createElement(SocialMediaButton, {
      "data-testid": "share-socialmedia-".concat(name.toLowerCase(), "-button"),
      color: color,
      "aria-label": "Compartilhar no ".concat(name),
      onClick: function onClick(e) {
        e.preventDefault();
        handleShareSocial(eventType, "".concat(href).concat(urlToCopy));
      }
    }, react.createElement(SharedActionsIcon, {
      name: name,
      color: iconColor,
      width: 24,
      height: 24
    })), react.createElement(Text/* default */.Z, {
      fontSize: 1,
      fontWeight: "regular",
      mb: 3,
      mt: 2
    }, name));
  })));
};
 false ? 0 : void 0;
SocialMedia.defaultProps = {
  device: 'mobile',
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  structure: {},
  urlToCopy: ''
};
SocialMedia.ssr = false;
SocialMedia.displayName = 'SocialMedia';
/* harmony default export */ var SocialMedia_SocialMedia = (SocialMedia);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/ShareLinksSkeleton.styles.js

var ShareLinksSkeleton_styles_templateObject, ShareLinksSkeleton_styles_templateObject2, ShareLinksSkeleton_styles_templateObject3, ShareLinksSkeleton_styles_templateObject4;


var variations = {
  circular: (0,styled_components_browser_esm/* css */.iv)(ShareLinksSkeleton_styles_templateObject || (ShareLinksSkeleton_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-radius: ", ";\n  "])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.circle')),
  rectangular: (0,styled_components_browser_esm/* css */.iv)(ShareLinksSkeleton_styles_templateObject2 || (ShareLinksSkeleton_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-radius: ", ";\n  "])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.default')),
  text: (0,styled_components_browser_esm/* css */.iv)(ShareLinksSkeleton_styles_templateObject3 || (ShareLinksSkeleton_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 1em;\n    border-radius: ", ";\n  "])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('radii.small'))
};
var Container = styled_components_browser_esm/* default.div */.ZP.div(ShareLinksSkeleton_styles_templateObject4 || (ShareLinksSkeleton_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", ";\n  height: ", ";\n\n  background: linear-gradient(\n      to right,\n      transparent,\n      rgba(255, 255, 255, 0.5) 50%,\n      transparent 80%\n    ),\n    ", ";\n  background-repeat: repeat-y;\n  background-size: 50px 500px;\n  background-position: 0 0;\n  animation: shine 1s infinite;\n  ", "\n  @keyframes shine {\n    to {\n      background-position: 100% 0, 0 0;\n    }\n  }\n"])), function (props) {
  return props.width || '120px';
}, function (props) {
  return props.height;
}, (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.whisper'), function (props) {
  return variations[props.variation];
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/ShareLinksSkeleton.js



var ShareLinksSkeleton = function ShareLinksSkeleton(_ref) {
  var width = _ref.width,
    height = _ref.height,
    variation = _ref.variation;
  return react.createElement(Container, {
    "data-testid": "share-links-skeleton",
    width: width,
    height: height,
    variation: variation
  });
};
 false ? 0 : void 0;
ShareLinksSkeleton.defaultProps = {
  height: '32px',
  variation: 'rectangular'
};
/* harmony default export */ var ShareLinksSkeleton_ShareLinksSkeleton = (ShareLinksSkeleton);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/index.js

// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var utils_build_esm = __webpack_require__(6422);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/SharedBag.styles.js

var SharedBag_styles_templateObject;



var SharedBagButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)(SharedBag_styles_templateObject || (SharedBag_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background-color: ", ";\n  font-size: ", "px;\n  margin: 0 auto;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.white')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.2')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/SharedBag.js


function SharedBag_regeneratorRuntime() { "use strict"; SharedBag_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }






var SharedBag = function SharedBag(_ref) {
  var sectionSharedBag = _ref.sectionSharedBag,
    product = _ref.product,
    storeNumericId = _ref.storeNumericId,
    cookieDomain = _ref.cookieDomain,
    onAddToReadyBagEvent = _ref.onAddToReadyBagEvent;
  var _useSharedBag = (0,graphql_build_esm.useSharedBag)(),
    addToSharedBag = _useSharedBag.addToSharedBag;
  var PMD_SHAREDBAG = utils_build_esm/* cookiesConstants.PMD_SHAREDBAG */.VD.PMD_SHAREDBAG;
  var showSectionSharedBag = (sectionSharedBag == null ? void 0 : sectionSharedBag.show) === 'true';
  var seller = product.seller.id;
  var sku = product.variationId;
  var sharedBagId = (0,utils_build_esm/* getCookie */.ej)(PMD_SHAREDBAG);
  var createSharedBag = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(SharedBag_regeneratorRuntime().mark(function _callee() {
      var _yield$addToSharedBag, sharedBagData;
      return SharedBag_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onAddToReadyBagEvent();
            _context.next = 3;
            return addToSharedBag({
              seller: seller,
              sharedBagId: sharedBagId,
              sku: sku,
              storeNumericId: storeNumericId
            });
          case 3:
            _yield$addToSharedBag = _context.sent;
            sharedBagData = _yield$addToSharedBag.data;
            if (sharedBagData && typeof (sharedBagData == null ? void 0 : sharedBagData.id) === 'string') {
              (0,utils_build_esm/* setCookie */.d8)({
                domain: cookieDomain,
                name: PMD_SHAREDBAG,
                value: sharedBagData.id
              });
              (0,utils_build_esm/* routePush */.dY)({
                path: "".concat(sectionSharedBag.url, "/").concat(sharedBagData.id),
                spa: false
              });
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createSharedBag() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!showSectionSharedBag) return null;
  return react.createElement(SharedBagButton, {
    "data-testid": "sharedbag-button",
    full: true,
    href: "#",
    onClick: createSharedBag,
    rel: "noopener",
    size: "small",
    variation: "outline",
    target: "_blank",
    uppercase: false,
    title: "ShoppingBag",
    startIcon: react.createElement(build_esm/* Icon */.JO$, {
      name: "ShoppingBag",
      width: 24,
      height: 24
    })
  }, sectionSharedBag.buttonLabel);
};
 false ? 0 : void 0;
SharedBag.defaultProps = {
  cookieDomain: '',
  onAddToReadyBagEvent: null,
  product: {
    seller: {
      id: ''
    },
    variationId: ''
  },
  sectionSharedBag: {
    buttonLabel: 'Adicionar na sacola pronta',
    show: 'false',
    title: 'Compartilhe produtos na sacola pronta',
    url: '#'
  },
  storeNumericId: ''
};
SharedBag.ssr = false;
SharedBag.displayName = 'SharedBag';
/* harmony default export */ var SharedBag_SharedBag = (SharedBag);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActions.styles.js

var ShareLinksActions_styles_templateObject;


var ContentInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(ShareLinksActions_styles_templateObject || (ShareLinksActions_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  padding-bottom: 16px;\n  gap: 20px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActions.js
















var ShareLinksContent = function ShareLinksContent(_ref) {
  var active = _ref.active,
    data = _ref.data,
    device = _ref.device,
    sectionSocial = _ref.sectionSocial,
    sectionSharedBag = _ref.sectionSharedBag,
    structure = _ref.structure;
  var _useState = (0,react.useState)(''),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    urlToCopy = _useState2[0],
    setUrlToCopy = _useState2[1];
  var channel = data.channel,
    product = data.product;
  var isDesktop = device === 'desktop';
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    _structure$route = structure.route,
    route = _structure$route === void 0 ? {} : _structure$route;
  var shortenlink = (0,useShortenLink/* default */.Z)('shortenlink-onelink', {
    addPartnerId: true,
    desktopLink: "".concat(config.domain).concat(asPath),
    link: "https://m.magazineluiza.com.br".concat(asPath == null ? void 0 : asPath.split(basePath).join(''))
  });
  (0,react.useEffect)(function () {
    if (!active) return;
    var url = sessionStorage.getItem("shorten_onelink");
    var sku = sessionStorage.getItem("sku");
    if (!url || url === 'null' || url === 'undefined' || sku !== route.productId) {
      setUrlToCopy('');
      shortenlink.handleShortenLink();
    } else setUrlToCopy(url);
  }, [structure, active]);
  (0,react.useEffect)(function () {
    if (shortenlink.shortLink) {
      sessionStorage.setItem('shorten_onelink', shortenlink.shortLink);
      sessionStorage.setItem('sku', route.productId);
      setUrlToCopy(shortenlink.shortLink);
    }
  }, [shortenlink.shortLink]);
  (0,react.useEffect)(function () {
    if (shortenlink.isLoading) {
      setUrlToCopy('');
    }
  }, [shortenlink.isLoading]);
  var handleEventCopy = function handleEventCopy() {
    publish('pmd:sharelinks:share:product:click', {
      pageType: structure == null ? void 0 : structure.name,
      productId: structure == null ? void 0 : structure.route.productId,
      productName: structure == null ? void 0 : structure.route.slug,
      shareAction: 'copiar-link'
    });
  };
  var handleAddToReadyBagEvent = function handleAddToReadyBagEvent() {
    publish('pmd:sharelinks:add:ready:bag:click', {
      productId: structure == null ? void 0 : structure.route.productId,
      productName: isDesktop ? structure == null ? void 0 : structure.route.slug : structure == null ? void 0 : structure.route.productSlug
    });
  };
  var renderLoadingSkeleton = function renderLoadingSkeleton() {
    return react.createElement(ContentInfo, {
      "data-testid": "share-links-actions"
    }, isDesktop && react.createElement(react.Fragment, null, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "100%",
      variation: "text"
    }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "100%",
      height: "52px",
      variation: "rectangular"
    })), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "100%",
      variation: "text"
    }), react.createElement(Flex/* default */.Z, {
      justifyContent: "flex-start",
      gap: "20px"
    }, react.createElement(Flex/* default */.Z, {
      flexDirection: "column",
      alignItems: "center",
      gap: "8px"
    }, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "44px",
      height: "44px",
      variation: "circular"
    }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "60px",
      variation: "text"
    })), react.createElement(Flex/* default */.Z, {
      flexDirection: "column",
      alignItems: "center",
      gap: "8px"
    }, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "44px",
      height: "44px",
      variation: "circular"
    }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "60px",
      variation: "text"
    }))), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
      width: "100%",
      height: "32px",
      variation: "rectangular"
    }));
  };
  var renderError = function renderError() {
    if (shortenlink.error.status === 401) return react.createElement(Flex/* default */.Z, {
      flexDirection: "column",
      alignItems: "center",
      gap: "10px"
    }, react.createElement(Text/* default */.Z, {
      color: "error.text",
      lineHeight: "1.2"
    }, "Ops! Parece que voc\xEA precisa fazer login no admin novamente para continuar."), react.createElement(Button/* default */.Z, {
      as: "a",
      variation: "outline",
      href: "/login",
      target: "_blank",
      rel: "noopener noreferrer",
      size: "small",
      endIcon: react.createElement(build_esm/* OpenLink */.QiM, {
        width: 20,
        height: 20
      }),
      full: true
    }, "Ir para o login"));
    return react.createElement(Text/* default */.Z, {
      color: "error.text",
      lineHeight: "1.2"
    }, "Poxa! Algo deu errado. Por favor, espere um pouquinho e tente de novo.");
  };
  var renderShareOptions = function renderShareOptions() {
    var _channel$data$, _channel$data$$value, _structure$config2;
    if (shortenlink.isLoading) return renderLoadingSkeleton();
    if (shortenlink.hasError) return renderError();
    return react.createElement(react.Fragment, null, isDesktop && react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
      fontSize: 1,
      fontWeight: "regular",
      mb: 2
    }, "Link do produto"), react.createElement(Box/* default */.Z, {
      onClick: handleEventCopy,
      "data-testid": "desk-copy-link-button"
    }, react.createElement(CopyToClipboard/* default */.Z, {
      value: urlToCopy
    }))), react.createElement(SocialMedia_SocialMedia, {
      "data-testid": "share-socialmedia",
      sectionSocial: sectionSocial,
      device: device,
      urlToCopy: urlToCopy,
      structure: structure
    }), react.createElement(SharedBag_SharedBag, {
      "data-testid": "share-bag",
      sectionSharedBag: sectionSharedBag,
      product: product,
      storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
      cookieDomain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.cookieDomain,
      onAddToReadyBagEvent: handleAddToReadyBagEvent
    }));
  };
  return react.createElement(ContentInfo, {
    "data-testid": "share-links-actions"
  }, renderShareOptions());
};
 false ? 0 : void 0;
ShareLinksContent.defaultProps = {
  active: false,
  data: {},
  device: 'mobile',
  sectionSharedBag: {
    buttonLabel: 'Adicionar à Sacola Pronta',
    show: 'false',
    url: '#'
  },
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  structure: {}
};
/* harmony default export */ var ShareLinksActions = ((0,withLayoutProps/* default */.Z)(ShareLinksContent));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/ShareLinksProduct.styles.js

var ShareLinksProduct_styles_templateObject, ShareLinksProduct_styles_templateObject2, ShareLinksProduct_styles_templateObject3, ShareLinksProduct_styles_templateObject4, _templateObject5, _templateObject6;





var ShareLinksProduct_styles_ContentInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(ShareLinksProduct_styles_templateObject || (ShareLinksProduct_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  margin-bottom: 20px;\n  gap: 20px;\n"])));
var ContentProduct = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(ShareLinksProduct_styles_templateObject2 || (ShareLinksProduct_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: 1px solid #dddddd;\n  border-radius: 6px;\n\n  ", "\n"])), function (_ref) {
  var device = _ref.device;
  return device === 'desktop' && (0,styled_components_browser_esm/* css */.iv)(ShareLinksProduct_styles_templateObject3 || (ShareLinksProduct_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-left: 40px;\n      margin-right: 40px;\n    "])));
});
var PriceContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)(ShareLinksProduct_styles_templateObject4 || (ShareLinksProduct_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  padding: 6px;\n  height: 50px;\n  border-radius: 0 0 6px 6px;\n  background-color: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.primary')(props);
});
var TextBestPrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: ", ";\n  color: ", ";\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.2'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.bold'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.text.white'));
var TextPrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-bottom: ", "px;\n  color: ", ";\n  text-decoration: line-through;\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontSizes.0'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.regular'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.1'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.text.white'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/ShareLinksProduct.js








var ShareLinksProduct = function ShareLinksProduct(_ref) {
  var _product$image;
  var data = _ref.data,
    device = _ref.device;
  var product = data.product;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    productPrice = _ref2.price;
  var _ref3 = productPrice || {},
    bestPrice = _ref3.bestPrice,
    price = _ref3.price;
  return react.createElement(ShareLinksProduct_styles_ContentInfo, {
    "data-testid": "share-links-product"
  }, react.createElement(Text/* default */.Z, {
    as: "h3",
    fontWeight: "bold"
  }, "Gerar link"), react.createElement(Text/* default */.Z, {
    as: "p",
    lineHeight: 1.2
  }, "Crie seu link e envie para os clientes. Se eles n\xE3o tiverem o app do Magalu instalado, ser\xE3o direcionados para sua loja."), react.createElement(Text/* default */.Z, {
    as: "p",
    lineHeight: 1.2
  }, "Pr\xE9-visualiza\xE7\xE3o:"), react.createElement(ContentProduct, {
    device: device
  }, react.createElement(Box/* default */.Z, {
    p: 3
  }, react.createElement(atoms/* Image */.Ee, {
    borderRadius: "10px",
    src: product == null ? void 0 : (_product$image = product.image) == null ? void 0 : _product$image.replace('{w}x{h}', '300x160'),
    alt: product == null ? void 0 : product.title,
    style: {
      maxHeight: '160px'
    }
  })), react.createElement(PriceContainer, null, react.createElement(TextPrice, null, (0,currencyFormatter/* default */.Z)({
    value: price
  })), react.createElement(TextBestPrice, {
    fontSize: 1,
    fontWeight: "medium",
    color: "white"
  }, (0,currencyFormatter/* default */.Z)({
    value: bestPrice
  })))));
};
 false ? 0 : void 0;
ShareLinksProduct.defaultProps = {
  data: {},
  device: 'desktop'
};
/* harmony default export */ var ShareLinksProduct_ShareLinksProduct = ((0,withLayoutProps/* default */.Z)(ShareLinksProduct));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/hooks/useScrollLock.js

var useScrollLock = function useScrollLock(device, active) {
  (0,react.useEffect)(function () {
    if (device === 'desktop') document.body.style.overflowX = 'hidden';
    if (device === 'mobile' && active) document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflowX = 'visible';
      document.body.style.overflow = 'visible';
    };
  }, [active]);
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/ShareLinks.styles.js

var ShareLinks_styles_templateObject, ShareLinks_styles_templateObject2, ShareLinks_styles_templateObject3, ShareLinks_styles_templateObject4, ShareLinks_styles_templateObject5, ShareLinks_styles_templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;




var CloseButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)(ShareLinks_styles_templateObject || (ShareLinks_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  border-radius: 100%;\n  height: 24px;\n  min-width: 24px;\n  padding: 0;\n"])));
var CloseButtonIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* Icon */.JO$)(ShareLinks_styles_templateObject2 || (ShareLinks_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: #51585c !important;\n"])));
var ShareLinks_styles_Container = styled_components_browser_esm/* default.div */.ZP.div(ShareLinks_styles_templateObject3 || (ShareLinks_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  display: flex;\n  max-height: 90%;\n  padding: 16px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 3px;\n  }\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n  ", "\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.white')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.light')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.primary.main')(props);
}, function (_ref) {
  var device = _ref.device;
  return device === 'mobile' && (0,styled_components_browser_esm/* css */.iv)(ShareLinks_styles_templateObject4 || (ShareLinks_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-top-left-radius: 32px;\n      border-top-right-radius: 32px;\n      bottom: -90%;\n      left: 0;\n      position: fixed;\n      right: 0;\n      width: 100%;\n      align-items: flex-start;\n      transition: all 0.3s ease-out;\n    "])));
}, function (_ref2) {
  var device = _ref2.device;
  return device === 'desktop' && (0,styled_components_browser_esm/* css */.iv)(ShareLinks_styles_templateObject5 || (ShareLinks_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      position: fixed;\n      width: 540px;\n      height: fit-content;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%) scale(0.95);\n      border-radius: 16px;\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n      background-color: ", ";\n      padding: 24px;\n      transition: opacity 0.5s ease, transform 0.5s ease;\n      opacity: 0;\n      pointer-events: none;\n    "])), function (props) {
    return (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.background.white')(props);
  });
}, function (_ref3) {
  var device = _ref3.device,
    active = _ref3.active;
  return device === 'desktop' && active && (0,styled_components_browser_esm/* css */.iv)(ShareLinks_styles_templateObject6 || (ShareLinks_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      opacity: 1;\n      transform: translate(-50%, -50%) scale(1);\n      pointer-events: auto;\n    "])));
}, function (_ref4) {
  var active = _ref4.active;
  return active && (0,styled_components_browser_esm/* css */.iv)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      z-index: 2;\n      bottom: 0;\n    "])));
});
var Content = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"])));
var ShareContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm/* themeGet */.R)('zIndices.3')(props);
});
var ShareOverlay = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  height: 100%;\n  transition: all 0.3s ease-out;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var active = _ref5.active;
  return active && (0,styled_components_browser_esm/* css */.iv)(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n      bottom: 0;\n      left: 0;\n      position: fixed;\n      right: 0;\n      top: 0;\n      transition: all 0.3s ease-in;\n      z-index: 1;\n    "])));
}, function (_ref6) {
  var device = _ref6.device;
  return device === 'desktop' && (0,styled_components_browser_esm/* css */.iv)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: block;\n    "])));
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/ShareLinks.js










var ShareLinks = function ShareLinks(props) {
  var data = props.data,
    staticProps = props["static"],
    structure = props.structure;
  var _staticProps$device = staticProps.device,
    device = _staticProps$device === void 0 ? 'desktop' : _staticProps$device;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isShareActive = _useState2[0],
    setIsShareActive = _useState2[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe;
  useScrollLock(device, isShareActive);
  var onCloseShareActive = function onCloseShareActive() {
    setIsShareActive(false);
  };
  (0,react.useEffect)(function () {
    subscribe('sharelinksbutton:click', function () {
      return setIsShareActive(true);
    });
  }, []);
  return react.createElement(ShareContainer, {
    "data-testid": "share-links"
  }, react.createElement(ShareLinks_styles_Container, {
    active: isShareActive,
    device: device,
    "data-testid": "share-links-content"
  }, react.createElement(CloseButton, {
    "data-testid": "btn-close-modal",
    name: "Close",
    onClick: onCloseShareActive,
    color: "none",
    "aria-label": "fechar o modal"
  }, react.createElement(CloseButtonIcon, {
    name: "Close"
  })), react.createElement(Content, null, react.createElement(ShareLinksProduct_ShareLinksProduct, {
    data: data,
    device: device
  }), react.createElement(ShareLinksActions, (0,esm_extends/* default */.Z)({
    active: isShareActive,
    data: data,
    structure: structure
  }, staticProps)))), react.createElement(ShareOverlay, {
    "data-testid": "share-links-overlay",
    device: device,
    active: isShareActive,
    onClick: onCloseShareActive
  }));
};
 false ? 0 : void 0;
ShareLinks.defaultProps = {
  data: {},
  "static": {
    device: 'desktop',
    sectionSharedBag: {
      buttonLabel: 'Adicionar à Sacola Pronta',
      show: 'false',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    }
  },
  structure: {}
};
ShareLinks.ssr = false;
ShareLinks.displayName = 'ShareLinks';
ShareLinks.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var ShareLinks_ShareLinks = ((0,withLayoutProps/* default */.Z)(ShareLinks));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/index.js


/***/ })

}]);